<template>
  <!-- NOTE (TEMPLATE) to build a general proposal and use it in the project as a component -->
  <div class="animated fadeIn" v-if="pageLoaded">
    <!-- loading component -->
    <Loading />
    <b-card
      v-if="role == 'researcher' && projectControl.adminMessage"
      header-bg-variant="warning"
      header-text-variant="white"
      header="پیام مدیر"
      style="border: 0"
      class="p-3 mb-5 bg-white rounded mt-0"
      >{{ projectControl.adminMessage }}</b-card
    >
    <b-card
      v-if="role == 'researcher' && !reports"
      style="border: 0"
      class="p-3 mb-5 bg-white rounded mt-0"
    >
      <h2 class="text-primary text-center">پژوهشگر گرامی</h2>

      <h4 class="text-dark text-center mt-4">
        <b-spinner type="grow"></b-spinner>
        لطفا منتظر شروع فرایند از سوی ادمین بمانید
        <b-spinner type="grow"></b-spinner>
      </h4>
    </b-card>
    <b-card v-else style="border: 0" class="mt-0 mb-0">
      <h3>
        کد فرصت مطالعاتی:
        {{
          role != "referee" ? projectControl.requestsCode : request.requestsCode
        }}
      </h3>
      <h4 class="text-dark" v-if="role != 'referee'">
        وضعیت کنترل پروژه: {{ projectControl.status }}
      </h4>
      <hr />

      <b-button
        style="float: left"
        variant="primary"
        v-if="tabIndex == 0"
        @click="saveDocx('doc')"
      >
        <i class="fa fa-file-word-o"></i>
        دریافت Word
      </b-button>
      <b-tabs pills v-model="tabIndex">
        <b-tab title="چکیده دوره‌" active lazy>
          <!-- docx -->
          <div v-show="false" id="doc">
            <div class="all" style="text-align: right">
              <h1
                style="
                  display: inline-block;
                  text-align: center;
                  padding: 5px 0;
                  border-bottom: 3px solid black;
                "
              >
                کد فرصت مطالعاتی:
                <span
                  style="direction: ltr; font-family: Bahnschrift SemiBold"
                  >{{ projectControl.requestsCode }}</span
                >
              </h1>
              <div>
                <h2 style="color: black; direction: rtl">
                  تاریخ خروجی: {{ exportDate }}
                </h2>
                <hr />
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  عنوان و حمایت‌های پیشین
                </h2>
                <div>
                  <ul>
                    <li :class="request.faSubject ? 'done' : 'required'">
                      <strong>عنوان دقیق دوره: </strong>{{ request.faSubject }}
                    </li>
                    <li
                      :class="request.initialIsSupported ? 'done' : 'required'"
                    >
                      <strong
                        >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها
                        استفاده کرده است؟
                      </strong>

                      {{ request.initialIsSupported ? "بله" : "خیر" }}
                    </li>

                    <li
                      v-if="
                        request.initialIsSupported &&
                        request.initialSupportedType != 'other'
                      "
                      :class="
                        request.initialSupportedType ? 'done' : 'required'
                      "
                    >
                      <strong> حمایت ها: </strong
                      >{{ request.initialSupportedType }}
                    </li>
                    <li
                      v-if="
                        request.initialSupportedType == 'other' &&
                        request.initialIsSupported
                      "
                      :class="request.initialOtherSupport ? 'done' : 'required'"
                    >
                      <strong>عنوان حمایت دریافتی: </strong>
                      {{ request.initialOtherSupport }}
                    </li>
                    <li
                      v-if="request.initialIsSupported"
                      :class="
                        request.initialSupportDescription ? 'done' : 'required'
                      "
                    >
                      <strong>توضیحات حمایت دریافتی: </strong><br />
                      {{ request.initialSupportDescription }}
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  اطلاعات اصلی دوره
                </h2>
                <div>
                  <ul>
                    <li :class="request.faSubject ? 'done' : 'required'">
                      <strong>عنوان به زبان فارسی: </strong
                      >{{ request.faSubject }}
                    </li>
                    <li :class="request.enSubject ? 'done' : 'required'">
                      <strong>عنوان به زبان انگلیسی: </strong
                      >{{ request.enSubject }}
                    </li>
                    <li :class="request.universityId ? 'done' : 'required'">
                      <strong>دانشگاه محل اجرای دوره: </strong>
                      {{
                        request.universityId
                          ? universities.filter(
                              (x) => x.id == request.universityId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == request.universityId
                              )[0].text
                            : ""
                          : ""
                      }}
                    </li>

                    <li
                      v-if="request.universityId == notUniversity"
                      :class="request.otherUniversity ? 'done' : 'required'"
                    >
                      <strong>نام دانشگاه: </strong
                      >{{ request.otherUniversity }}
                    </li>
                    <li
                      v-if="request.mehvarId != notMehvar"
                      :class="request.mehvarId ? 'done' : 'required'"
                    >
                      <strong>محور دوره: </strong>
                      {{
                        request.mehvarId
                          ? mehvars.filter((x) => x.id == request.mehvarId)[0]
                            ? mehvars.filter((x) => x.id == request.mehvarId)[0]
                                .text
                            : ""
                          : ""
                      }}
                    </li>
                    <li
                      v-if="request.mehvarId == notMehvar"
                      :class="request.mehvarId ? 'done' : 'required'"
                    >
                      <strong>محور دوره: </strong> سایر محورها
                    </li>
                    <li
                      v-if="request.mehvarId == notMehvar"
                      :class="request.otherMehvars ? 'done' : 'required'"
                    >
                      <strong>نام محور: </strong>{{ otherMehvars }}
                    </li>
                    <li>
                      <strong>ماهیت دوره: </strong>

                      <ul>
                        <li v-if="request.typeStudy">مطالعاتی</li>
                        <li v-if="request.typeSystemicDevelopmental">
                          سیستمی و توسعه‌ای
                        </li>
                        <li v-if="request.typePractical">کاربردی</li>
                      </ul>
                    </li>
                    <li>
                      <strong>حوزه دوره: </strong>
                      <ul>
                        <li v-if="request.zoneMedicine">پزشکی</li>
                        <li v-if="request.zoneAgriculture">کشاورزی</li>
                        <li v-if="request.zoneEnvironment">محیط زیست</li>
                        <li v-if="request.zoneIndustrial">صنعتی</li>
                        <li v-if="request.zoneBioComputing">رایانش زیستی</li>
                        <li v-if="request.zoneOther">سایر</li>
                      </ul>
                    </li>
                    <li
                      :class="request.oppurtunityActions ? 'done' : 'required'"
                    >
                      <strong>
                        گزارش خلاصه اقداماتی که قصد دارید در دانشگاه مقصد در طی
                        دوره انجام دهید: </strong
                      ><br />{{ request.oppurtunityActions }}
                    </li>
                    <br />

                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="request.oppurtunityAchievements"
                      :fields="achievmentFieldsDoc"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                  </ul>
                </div>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  اطلاعات متقاضی
                </h2>
                <div>
                  <ul>
                    <li :class="request.researcherName ? 'done' : 'required'">
                      <strong>نام: </strong>{{ request.researcherName }}
                    </li>
                    <li
                      :class="request.researcherLastName ? 'done' : 'required'"
                    >
                      <strong>نام خانوادگی: </strong
                      >{{ request.researcherLastName }}
                    </li>
                    <li
                      :class="request.researcherNatCode ? 'done' : 'required'"
                    >
                      <strong>کدملی: </strong>{{ request.researcherNatCode }}
                    </li>
                    <li :class="request.researcherMobile ? 'done' : 'required'">
                      <strong>تلفن همراه: </strong
                      >{{ request.researcherMobile }}
                    </li>
                    <li :class="request.researcherFax ? 'done' : 'required'">
                      <strong>دورنگار: </strong>{{ request.researcherFax }}
                    </li>
                    <li :class="request.researcherEmail ? 'done' : 'required'">
                      <strong>پست الکترونیکی: </strong
                      >{{ request.researcherEmail }}
                    </li>
                    <li :class="request.researcherState ? 'done' : 'required'">
                      <strong>استان: </strong>{{ request.researcherState }}
                    </li>
                    <li :class="request.researcherCity ? 'done' : 'required'">
                      <strong>شهر: </strong>{{ request.researcherCity }}
                    </li>
                    <li
                      :class="
                        request.researcherUniversityId ? 'done' : 'required'
                      "
                    >
                      <strong>دانشگاه محل تحصیل: </strong>
                      {{
                        request.researcherUniversityId
                          ? universities.filter(
                              (x) => x.id == request.researcherUniversityId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == request.researcherUniversityId
                              )[0].text
                            : "-"
                          : "-"
                      }}
                    </li>
                    <li
                      :class="
                        request.researcherUniversityOther ? 'done' : 'required'
                      "
                      v-if="request.researcherUniversityId == notUniversity"
                    >
                      <strong>نام دانشگاه: </strong
                      >{{ request.researcherUniversityOther }}
                    </li>
                    <li class="'done'">
                      <strong>دانشگاه محل اشتغال: </strong>
                      {{
                        request.researcherUniversityJobId
                          ? universities.filter(
                              (x) => x.id == request.researcherUniversityJobId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == request.researcherUniversityJobId
                              )[0].text
                            : "-"
                          : "-"
                      }}
                    </li>
                    <li
                      v-if="request.researcherUniversityJobId == notUniversity"
                    >
                      <strong>نام دانشگاه: </strong
                      >{{ request.researcherUniversityJobOther }}
                    </li>
                    <li :class="request.researcherIBAN ? 'done' : 'required'">
                      <strong>شماره شبا: </strong>{{ request.researcherIBAN }}
                    </li>
                    <li
                      :class="request.researcherBankName ? 'done' : 'required'"
                    >
                      <strong>نام بانک: </strong
                      >{{ request.researcherBankName }}
                    </li>
                    <li
                      :class="
                        request.researcherUniversityDestination
                          ? 'done'
                          : 'required'
                      "
                    >
                      <strong>دانشگاه مقصد: </strong
                      >{{ request.researcherUniversityDestination }}
                    </li>
                    <li
                      :class="
                        request.researcherCountryDestination
                          ? 'done'
                          : 'required'
                      "
                    >
                      <strong>کشور مقصد: </strong
                      >{{ request.researcherCountryDestination }}
                    </li>
                    <li v-if="request.researcherMasterStudent == 'master'">
                      <strong>شاخص Hindex استاد: </strong
                      >{{ request.researcherHindex }}
                    </li>
                    <li v-if="request.researcherMasterStudent == 'student'">
                      <strong>شاخص Hindex دانشجو: </strong
                      >{{ request.researcherHindex }}
                    </li>
                    <li v-if="request.researcherMasterStudent == 'student'">
                      <strong>نمره امتحان جامع دانشجو: </strong
                      >{{ request.researcherComprehensiveTestMark }}
                    </li>
                    <li v-if="request.researcherMasterStudent == 'student'">
                      <strong>تاریخ امتحان جامع دانشجو: </strong
                      ><span style="direction: ltr">{{
                        request.researcherComprehensiveTestDate
                      }}</span>
                    </li>
                    <li
                      :class="
                        request.researcherPhDThesisSubject ? 'done' : 'required'
                      "
                    >
                      <strong>عنوان طرح رساله دکتری: </strong
                      >{{ request.researcherPhDThesisSubject }}
                    </li>
                    <li
                      v-if="request.researcherMasterStudent == 'student'"
                      :class="
                        request.researcherPhDThesisDefenceDate
                          ? 'done'
                          : 'required'
                      "
                    >
                      <strong>تاریخ تصویب رساله: </strong
                      ><span style="direction: ltr">{{
                        request.researcherPhDThesisDefenceDate
                      }}</span>
                    </li>
                    <br />

                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="request.researcherArticleISI"
                      :fields="articlesFieldsDoc"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                  </ul>
                </div>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  اطلاعات اساتید
                </h2>
                <div>
                  <strong style="color: blue">استاد راهنمای داخلی</strong>
                  <ul>
                    <li :class="supervisors[0].name ? 'done' : 'required'">
                      <strong>نام: </strong>{{ supervisors[0].name }}
                    </li>
                    <li :class="supervisors[0].lastName ? 'done' : 'required'">
                      <strong>نام خانوادگی: </strong
                      >{{ supervisors[0].lastName }}
                    </li>
                    <li :class="supervisors[0].natCode ? 'done' : 'required'">
                      <strong>کدملی: </strong>{{ supervisors[0].natCode }}
                    </li>
                    <li :class="supervisors[0].mobile ? 'done' : 'required'">
                      <strong>تلفن همراه: </strong>{{ supervisors[0].mobile }}
                    </li>

                    <li :class="supervisors[0].email ? 'done' : 'required'">
                      <strong>پست الکترونیکی: </strong
                      >{{ supervisors[0].email }}
                    </li>
                    <li :class="supervisors[0].position ? 'done' : 'required'">
                      <strong>سمت: </strong>{{ supervisors[0].position }}
                    </li>

                    <li
                      :class="supervisors[0].universityId ? 'done' : 'required'"
                    >
                      <strong>دانشگاه محل تحصیل: </strong>
                      {{
                        universities.filter(
                          (x) => x.id == supervisors[0].universityId
                        ).length
                          ? universities.filter(
                              (x) => x.id == supervisors[0].universityId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == supervisors[0].universityId
                              )[0].text
                            : "---"
                          : "---"
                      }}
                    </li>
                    <li
                      v-if="supervisors[0].universityId == notUniversity"
                      :class="
                        supervisors[0].universityOther ? 'done' : 'required'
                      "
                    >
                      <strong>نام دانشگاه: </strong
                      >{{ supervisors[0].universityOther }}
                    </li>
                    <li
                      :class="
                        supervisors[0].universityJobId ? 'done' : 'required'
                      "
                    >
                      <strong>دانشگاه محل اشتغال: </strong>
                      {{
                        supervisors[0].universityJobId
                          ? universities.filter(
                              (x) => x.id == supervisors[0].universityJobId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == supervisors[0].universityJobId
                              )[0].text
                            : "-"
                          : "-"
                      }}
                    </li>
                    <li
                      v-if="supervisors[0].universityJobId == notUniversity"
                      :class="
                        supervisors[0].universityJobOther ? 'done' : 'required'
                      "
                    >
                      <strong>نام دانشگاه: </strong
                      >{{ supervisors[0].universityJobOther }}
                    </li>
                    <hr />
                    <strong style="color: blue">استاد راهنمای خارجی</strong>
                    <li :class="advisors[0].name ? 'done' : 'required'">
                      <strong>نام: </strong>{{ advisors[0].name }}
                    </li>
                    <li :class="advisors[0].lastName ? 'done' : 'required'">
                      <strong>نام خانوادگی: </strong>{{ advisors[0].lastName }}
                    </li>
                    <li :class="advisors[0].mobile ? 'done' : 'required'">
                      <strong>تلفن همراه: </strong>{{ advisors[0].mobile }}
                    </li>

                    <li :class="advisors[0].email ? 'done' : 'required'">
                      <strong>پست الکترونیکی: </strong>{{ advisors[0].email }}
                    </li>
                    <li :class="advisors[0].position ? 'done' : 'required'">
                      <strong>سمت: </strong>{{ advisors[0].position }}
                    </li>
                    <li
                      :class="advisors[0].universityOther ? 'done' : 'required'"
                    >
                      <strong>دانشگاه محل تحصیل: </strong>
                      {{ advisors[0].universityOther }}
                    </li>
                    <li :class="advisors[0].lastDegree ? 'done' : 'required'">
                      <strong>آخرین مدرک تحصیلی: </strong>
                      {{ advisors[0].lastDegree }}
                    </li>
                    <li
                      :class="
                        advisors[0].universityJobOther ? 'done' : 'required'
                      "
                    >
                      <strong>دانشگاه محل اشتغال: </strong>
                      {{ advisors[0].universityJobOther }}
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  اطلاعات تجاری‌سازی
                </h2>
                <h4 style="font-size: 18px">
                  نوع تجاری‌سازی:
                  {{
                    request.commercializingType == "company"
                      ? "شرکت دانش بنیان"
                      : request.commercializingType == "accelerator"
                      ? "شتاب‌دهنده"
                      : "فاقد اطلاعات تجاری‌سازی می‌باشد"
                  }}
                </h4>
                <div v-if="request.commercializingType == 'company'">
                  <ul>
                    <div v-if="request.companyId != notCompany">
                      <li :class="request.companyName ? 'done' : 'required'">
                        <strong>نام شرکت دانش بنیان: </strong
                        >{{ request.companyName }}
                      </li>
                      <li class="done">
                        <strong>شماره ثبت شرکت: </strong
                        >{{
                          request.companyRegistrationNumber
                            ? request.companyRegistrationNumber
                            : "-"
                        }}
                      </li>
                      <li class="done">
                        <strong>شناسه ملی شرکت: </strong
                        >{{
                          request.companyNationalId
                            ? request.companyNationalId
                            : "-"
                        }}
                      </li>
                    </div>
                    <div v-else>
                      <li
                        :class="request.otherCompanyName ? 'done' : 'required'"
                      >
                        <strong>نام شرکت دانش بنیان: </strong
                        >{{ request.otherCompanyName }}
                      </li>
                      <li
                        :class="
                          request.otherCompanyRegistrationNumber
                            ? 'done'
                            : 'required'
                        "
                      >
                        <strong>شماره ثبت شرکت: </strong
                        >{{ request.otherCompanyRegistrationNumber }}
                      </li>
                      <li
                        :class="
                          request.otherCompanyNationalId ? 'done' : 'required'
                        "
                      >
                        <strong>شناسه ملی شرکت: </strong
                        >{{ request.otherCompanyNationalId }}
                      </li>
                    </div>
                    <li :class="request.companyProducts ? 'done' : 'required'">
                      <strong>معرفی فناوری یا محصولات شرکت: </strong><br />
                      {{ request.companyProducts }}
                    </li>
                    <li
                      :class="request.companyContactInfo ? 'done' : 'required'"
                    >
                      <strong
                        >آدرس پستی / شماره تماس/ پست الکترونیک شرکت: </strong
                      ><br />
                      {{ request.companyContactInfo }}
                    </li>
                    <li
                      :class="request.companyDescription ? 'done' : 'required'"
                    >
                      <strong>توضیحات: </strong><br />
                      {{ request.companyDescription }}
                    </li>
                  </ul>
                </div>
                <ul v-else-if="request.commercializingType == 'accelerator'">
                  <li>
                    <strong class="text-primary">نام شتاب‌دهنده:</strong>

                    {{ request.acceleratorName }}
                  </li>
                </ul>
                <div v-else-if="request.commercializingType == 'none'">
                  <div
                    class="d-flex flex-row mb-2"
                    v-if="request.commercializingObligation1"
                  >
                    <b-form-checkbox
                      disabled
                      v-model="request.commercializingObligation1"
                      @change="reactivity = !reactivity"
                    ></b-form-checkbox
                    ><span class="ps-2">
                      تایید میکنم با انتخاب این گزینه تا قبل از تایید درخواست
                      توسط یکی از شتاب‌دهنده‌ها یا شرکت‌های مجاز، ستاد توسعه
                      زیست فناوری هیچگونه مسئولیتی در قبال درخواست من نخواهد
                      داشت.
                    </span>
                  </div>
                  <div
                    class="d-flex flex-row mb-2"
                    v-if="request.commercializingObligation2"
                  >
                    <b-form-checkbox
                      disabled
                      v-model="request.commercializingObligation2"
                      @change="reactivity = !reactivity"
                    ></b-form-checkbox>
                    <span class="ps-2">
                      تایید میکنم با انتخاب این گزینه، کلیه اطلاعات شخصی و علمی
                      این درخواست، در اختیار شتاب‌دهنده‌ها و شرکت‌های مجاز قرار
                      خواهد گرفت تا بتوانند با بررسی اطلاعات، درخواست بنده را
                      بررسی و تایید کنند.
                    </span>
                  </div>
                </div>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  زمان‌بندی دوره
                </h2>

                <b-table
                  responsive
                  small
                  show-empty
                  head-variant="dark"
                  :items="request.gantData"
                  :fields="timeFieldsDoc"
                  empty-text="رکوردی برای نمایش وجود ندارد"
                  class="table table-secondary"
                >
                  <template v-slot:head()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.label }}
                    </div>
                  </template>
                  <template v-slot:cell()="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.value }}
                    </div>
                  </template>
                  <template v-slot:cell(index)="data">
                    <div style="text-align: center; vertical-align: middle">
                      {{ data.index + 1 }}
                    </div>
                  </template>
                </b-table>
              </div>
              <hr />
              <div>
                <h2
                  style="display: inline-block; text-align: center; color: blue"
                >
                  تعهدات
                </h2>
                <div>
                  <ul>
                    <li v-if="request.promiseArrays[0]">
                      این دوره در مدت زمان اعلام شده انجام می‌گردد و مسئولیت
                      تاخیر در انجام دوره بر عهده مجری می‌باشد. مدت زمان:
                      {{
                        request.gantData.length > 0
                          ? (Math.max(
                              ...request.gantData.map((x) =>
                                new Date(
                                  moment(x.returnDate, "jYYYY/jMM/jDD").format(
                                    "YYYY-MM-DD"
                                  )
                                ).getTime()
                              )
                            ) -
                              Math.min(
                                ...request.gantData.map((x) =>
                                  new Date(
                                    moment(
                                      x.dispatchDate,
                                      "jYYYY/jMM/jDD"
                                    ).format("YYYY-MM-DD")
                                  ).getTime()
                                )
                              )) /
                              3600 /
                              24 /
                              1000 +
                            " روز"
                          : ""
                      }}
                    </li>
                    <li v-if="request.promiseArrays[2]">
                      توافق بین دانشگاه و صنعت در خصوص دستاوردهای دوره وجود
                      دارد.
                    </li>
                    <li v-if="request.promiseArrays[3]">
                      کلیه اصلاحات در موعد مقرر و طی 2 هفته توسط اینجانب انجام و
                      در سایت بارگذاری می‌گردد.
                    </li>
                    <li v-if="request.promiseArrays[4]">
                      دستاوردهای دوره مشخص است و مستندات ارائه شده است.
                    </li>
                    <li v-if="request.promiseArrays[5]">
                      بهره‌بردار نهایی دستاوردهای دوره مشخص است و مستندات ارائه
                      شده است. <span v-if="request.commercializingType != 'none'">
                    نام بهره‌بردار:
                    <span v-if="request.commercializingType == 'company'">{{
                      request.companyId == notCompany
                        ? request.otherCompanyName
                        : request.companyName
                    }}</span>
                    <span v-else>{{
                      request.acceleratorId
                        ? accelerators.filter(
                            (x) => x.id == request.acceleratorId
                          )[0].text
                        : ""
                    }}</span>
                  </span>
                    </li>
                    <li v-if="request.promiseArrays[6]">
                      کلیه گزارش‌ها و خروجی‌ها و دستاوردها در پایان دوره به ستاد
                      زیست فناوری ارسال و تحویل داده می‌شود.
                    </li>
                    <li v-if="request.promiseArrays[7]">
                      ثبت اطلاعات در سامانه هیچ تعهدی را برای ستاد ایجاد نمی‌کند
                      و به منزله ثبت درخواست متقاضی است.
                    </li>
                    <li v-if="request.promiseArrays[8]">
                      پروپوزال رساله دکتری اینجانب مصوب شده است.
                    </li>
                    <li v-if="request.promiseArrays[9]">
                      امتحان جامع با موفقیت سپری شده است
                    </li>
                    <li v-if="request.promiseArrays[10]">
                      میزان شاخص (Hindex) اینجانب صحت دارد
                    </li>
                    <li v-if="request.promiseArrays[11]">
                      دعوتنامه معتبر از کشور مقصد دریافت شده است.
                    </li>
                    <li v-if="request.promiseArrays[12]">
                      کلیه موارد فوق مورد تایید اینجانب
                      {{
                        (request.researcherName ? request.researcherName : '-') +
                        " " +
                        request.researcherLastName
                      }}
                      به عنوان متقاضی و اساتید راهنما می‌باشد.
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
            </div>
          </div>
          <!-- docx -->
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-1 variant="dark">
                <h5 class="mb-0">عنوان و حمایت‌های پیشین&nbsp;</h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-1"
              accordion="my-accordion"
              role="tabpanel"
              visible
            >
              <b-card-body>
                <b-card-text>
                  <ul>
                    <li :class="request.faSubject ? 'done' : 'required'">
                      <b>عنوان دقیق دوره:</b>{{ request.faSubject }}
                    </li>
                    <li class="done">
                      <b
                        >آیا این طرح از حمایت‌های قبلی ستاد یا سایر نهادها
                        استفاده کرده است؟</b
                      >
                      <b-form-radio-group
                        v-model="request.initialIsSupported"
                        disabled
                      >
                        <b-form-radio :value="true">بله</b-form-radio>
                        <b-form-radio :value="false">خیر</b-form-radio>
                      </b-form-radio-group>
                    </li>

                    <li
                      v-if="
                        request.initialIsSupported &&
                        request.initialSupportedType != 'other'
                      "
                      :class="
                        request.initialSupportedType ? 'done' : 'required'
                      "
                    >
                      <b>حمایت ها:</b> {{ request.initialSupportedType }}
                    </li>
                    <li
                      v-if="
                        request.initialSupportedType == 'other' &&
                        request.initialIsSupported
                      "
                      :class="request.initialOtherSupport ? 'done' : 'required'"
                    >
                      <b>عنوان حمایت دریافتی:</b>
                      {{ request.initialOtherSupport }}
                    </li>
                    <li
                      v-if="request.initialIsSupported"
                      :class="
                        request.initialSupportDescription ? 'done' : 'required'
                      "
                    >
                      <b>توضیحات حمایت دریافتی:</b>
                      {{ request.initialSupportDescription }}
                    </li>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1 border-0" role="tab">
              <b-button block v-b-toggle.accordion-2 variant="dark">
                <h5 class="mb-0" style="display: inline-block">
                  اطلاعات اصلی دوره
                </h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-2"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="p-3">
                  <ul class="p-2">
                    <li :class="request.faSubject ? 'done' : 'required'">
                      <b>عنوان به زبان فارسی:</b> {{ request.faSubject }}
                    </li>
                    <li :class="request.enSubject ? 'done' : 'required'">
                      <b>عنوان به زبان انگلیسی:</b> {{ request.enSubject }}
                    </li>
                    <li :class="request.universityId ? 'done' : 'required'">
                      <b>دانشگاه محل اجرای دوره:</b>
                      {{
                        request.universityId
                          ? universities.filter(
                              (x) => x.id == request.universityId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == request.universityId
                              )[0].text
                            : ""
                          : ""
                      }}
                    </li>
                    <li
                      v-if="request.universityId == notUniversity"
                      :class="request.otherUniversity ? 'done' : 'required'"
                    >
                      <b>نام دانشگاه:</b> {{ request.otherUniversity }}
                    </li>
                    <li
                      v-if="request.mehvarId != notMehvar"
                      :class="request.mehvarId ? 'done' : 'required'"
                    >
                      <b>محور دوره:</b>
                      {{
                        request.mehvarId
                          ? mehvars.filter((x) => x.id == request.mehvarId)[0]
                            ? mehvars.filter((x) => x.id == request.mehvarId)[0]
                                .text
                            : ""
                          : ""
                      }}
                    </li>
                    <li
                      v-if="request.mehvarId == notMehvar"
                      :class="request.mehvarId ? 'done' : 'required'"
                    >
                      <b>محور دوره:</b> سایر محورها
                    </li>
                    <li
                      v-if="request.mehvarId == notMehvar"
                      :class="request.otherMehvars ? 'done' : 'required'"
                    >
                      <b>نام محور:</b> {{ request.otherMehvars }}
                    </li>
                    <li
                      :class="
                        request.typeStudy ||
                        request.typeSystemicDevelopmental ||
                        request.typePractical
                          ? 'done'
                          : 'required'
                      "
                    >
                      <b>ماهیت دوره:</b>
                      <b-form-group disabled>
                        <b-form-checkbox v-model="request.typeStudy"
                          >مطالعاتی</b-form-checkbox
                        >
                        <b-form-checkbox
                          v-model="request.typeSystemicDevelopmental"
                          >سیستمی و توسعه‌ای</b-form-checkbox
                        >
                        <b-form-checkbox v-model="request.typePractical"
                          >کاربردی</b-form-checkbox
                        >
                      </b-form-group>
                    </li>
                    <li
                      :class="
                        request.zoneMedicine ||
                        request.zoneAgriculture ||
                        request.zoneEnvironment ||
                        request.zoneIndustrial ||
                        request.zoneBioComputing ||
                        request.zoneOther
                          ? 'done'
                          : 'required'
                      "
                    >
                      <b>حوزه دوره:</b>
                      <b-form-group disabled>
                        <b-form-checkbox v-model="request.zoneMedicine"
                          >پزشکی</b-form-checkbox
                        >
                        <b-form-checkbox v-model="request.zoneAgriculture"
                          >کشاورزی</b-form-checkbox
                        >
                        <b-form-checkbox v-model="request.zoneEnvironment"
                          >محیط زیست</b-form-checkbox
                        >
                        <b-form-checkbox v-model="request.zoneIndustrial"
                          >صنعتی</b-form-checkbox
                        >
                        <b-form-checkbox v-model="request.zoneBioComputing"
                          >رایانش زیستی</b-form-checkbox
                        >
                        <b-form-checkbox v-model="request.zoneOther"
                          >سایر</b-form-checkbox
                        >
                      </b-form-group>
                    </li>
                    <li
                      :class="request.oppurtunityActions ? 'done' : 'required'"
                    >
                      <b
                        >گزارش خلاصه اقداماتی که قصد دارید در دانشگاه مقصد در طی
                        دوره انجام دهید:</b
                      >
                      {{ request.oppurtunityActions }}
                    </li>
                    <br />
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="request.oppurtunityAchievements"
                      :fields="achievmentFields"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                    </b-table>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-3 variant="light">
                <h5 class="mb-0" style="display: inline-block">
                  اطلاعات متقاضی
                </h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-3"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="p-3">
                  <ul class="p-2">
                    <li :class="request.researcherName ? 'done' : 'required'">
                      <b>نام:</b> {{ request.researcherName }}
                    </li>
                    <li
                      :class="request.researcherLastName ? 'done' : 'required'"
                    >
                      <b>نام خانوادگی:</b> {{ request.researcherLastName }}
                    </li>
                    <li
                      :class="request.researcherNatCode ? 'done' : 'required'"
                    >
                      <b>کدملی:</b>{{ request.researcherNatCode }}
                    </li>
                    <li :class="request.researcherMobile ? 'done' : 'required'">
                      <b>تلفن همراه:</b> {{ request.researcherMobile }}
                    </li>
                    <li :class="request.researcherFax ? 'done' : 'required'">
                      <b>دورنگار:</b> {{ request.researcherFax }}
                    </li>
                    <li :class="request.researcherEmail ? 'done' : 'required'">
                      <b>پست الکترونیکی:</b> {{ request.researcherEmail }}
                    </li>
                    <li :class="request.researcherState ? 'done' : 'required'">
                      <b>استان:</b> {{ request.researcherState }}
                    </li>
                    <li :class="request.researcherCity ? 'done' : 'required'">
                      <b>شهر:</b> {{ request.researcherCity }}
                    </li>
                    <li
                      :class="
                        request.researcherUniversityId ? 'done' : 'required'
                      "
                    >
                      <b>دانشگاه محل تحصیل:</b>
                      {{
                        universities.filter(
                          (x) => x.id == request.researcherUniversityId
                        ).length
                          ? universities.filter(
                              (x) => x.id == request.researcherUniversityId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == request.researcherUniversityId
                              )[0].text
                            : "---"
                          : "---"
                      }}
                    </li>
                    <li
                      v-if="request.researcherUniversityId == notUniversity"
                      :class="
                        request.researcherUniversityOther ? 'done' : 'required'
                      "
                    >
                      <b>نام دانشگاه:</b>
                      {{ request.researcherUniversityOther }}
                    </li>
                    <li class="'done'">
                      <b> دانشگاه محل اشتغال:</b>
                      {{
                        request.researcherUniversityJobId
                          ? universities.filter(
                              (x) => x.id == request.researcherUniversityJobId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == request.researcherUniversityJobId
                              )[0].text
                            : "-"
                          : "-"
                      }}
                    </li>
                    <li
                      v-if="request.researcherUniversityJobId == notUniversity"
                    >
                      <b>نام دانشگاه:</b>
                      {{ request.researcherUniversityJobOther }}
                    </li>
                    <li :class="request.researcherIBAN ? 'done' : 'required'">
                      <b>شماره شبا:</b> {{ request.researcherIBAN }}
                    </li>
                    <li
                      :class="request.researcherBankName ? 'done' : 'required'"
                    >
                      <b>نام بانک:</b> {{ request.researcherBankName }}
                    </li>
                    <li
                      :class="
                        request.researcherUniversityDestination
                          ? 'done'
                          : 'required'
                      "
                    >
                      <b>دانشگاه مقصد:</b>
                      {{ request.researcherUniversityDestination }}
                    </li>
                    <li
                      :class="
                        request.researcherCountryDestination
                          ? 'done'
                          : 'required'
                      "
                    >
                      <b>کشور مقصد:</b>
                      {{ request.researcherCountryDestination }}
                    </li>
                    <li v-if="request.researcherMasterStudent == 'master'">
                      <b>شاخص Hindex استاد:</b> {{ request.researcherHindex }}
                    </li>
                    <li v-if="request.researcherMasterStudent == 'student'">
                      <b>شاخص Hindex دانشجو:</b> {{ request.researcherHindex }}
                    </li>
                    <li v-if="request.researcherMasterStudent == 'student'">
                      <b>نمره امتحان جامع دانشجو:</b>
                      {{ request.researcherComprehensiveTestMark }}
                    </li>
                    <li v-if="request.researcherMasterStudent == 'student'">
                      <b>تاریخ امتحان جامع دانشجو:</b>
                      {{ request.researcherComprehensiveTestDate }}
                    </li>
                    <li
                      :class="
                        request.researcherPhDThesisSubject ? 'done' : 'required'
                      "
                    >
                      <b>عنوان طرح رساله دکتری:</b>
                      {{ request.researcherPhDThesisSubject }}
                    </li>
                    <li
                      v-if="request.researcherMasterStudent == 'student'"
                      :class="
                        request.researcherPhDThesisDefenceDate
                          ? 'done'
                          : 'required'
                      "
                    >
                      <b>تاریخ تصویب رساله:</b>
                      {{ request.researcherPhDThesisDefenceDate }}
                    </li>
                    <br />
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="request.researcherArticleISI"
                      :fields="articlesFields"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>

                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                      <template v-slot:cell(upload)="data">
                        <div style="text-align: center; vertical-align: middle">
                          <a
                            v-if="data.item.file.isUploaded"
                            class="btn btn-success small"
                            :href="data.item.uploadedFile.url"
                            target="_blank"
                          >
                            دانلود
                          </a>
                          <p v-else>فایل آپلود نشده است</p>
                        </div>
                      </template>
                    </b-table>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-4 variant="warning">
                <h5 class="mb-0" style="display: inline-block">
                  اطلاعات اساتید
                </h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-4"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="p-3">
                  <p>استاد راهنمای داخلی</p>
                  <ul class="p-2">
                    <li :class="supervisors[0].name ? 'done' : 'required'">
                      <b>نام:</b> {{ supervisors[0].name }}
                    </li>
                    <li :class="supervisors[0].lastName ? 'done' : 'required'">
                      <b>نام خانوادگی:</b> {{ supervisors[0].lastName }}
                    </li>
                    <li :class="supervisors[0].natCode ? 'done' : 'required'">
                      <b>کدملی:</b>{{ supervisors[0].natCode }}
                    </li>
                    <li :class="supervisors[0].mobile ? 'done' : 'required'">
                      <b>تلفن همراه:</b> {{ supervisors[0].mobile }}
                    </li>

                    <li :class="supervisors[0].email ? 'done' : 'required'">
                      <b>پست الکترونیکی:</b> {{ supervisors[0].email }}
                    </li>
                    <li :class="supervisors[0].position ? 'done' : 'required'">
                      <b> سمت:</b> {{ supervisors[0].position }}
                    </li>
                    <li
                      :class="supervisors[0].universityId ? 'done' : 'required'"
                    >
                      <b>دانشگاه محل تحصیل:</b>
                      {{
                        universities.filter(
                          (x) => x.id == supervisors[0].universityId
                        ).length
                          ? universities.filter(
                              (x) => x.id == supervisors[0].universityId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == supervisors[0].universityId
                              )[0].text
                            : "---"
                          : "---"
                      }}
                    </li>
                    <li
                      v-if="supervisors[0].universityId == notUniversity"
                      :class="
                        supervisors[0].universityOther ? 'done' : 'required'
                      "
                    >
                      <b>نام دانشگاه:</b> {{ supervisors[0].universityOther }}
                    </li>
                    <li
                      :class="
                        supervisors[0].universityJobId ? 'done' : 'required'
                      "
                    >
                      <b>دانشگاه محل اشتغال:</b>
                      {{
                        supervisors[0].universityJobId
                          ? universities.filter(
                              (x) => x.id == supervisors[0].universityJobId
                            )[0]
                            ? universities.filter(
                                (x) => x.id == supervisors[0].universityJobId
                              )[0].text
                            : "-"
                          : "-"
                      }}
                    </li>
                    <li
                      v-if="supervisors[0].universityJobId == notUniversity"
                      :class="
                        supervisors[0].universityJobOther ? 'done' : 'required'
                      "
                    >
                      <b>نام دانشگاه:</b>
                      {{ supervisors[0].universityJobOther }}
                    </li>
                    <hr />
                    <p>استاد راهنمای خارجی</p>
                    <li :class="advisors[0].name ? 'done' : 'required'">
                      <b>نام:</b> {{ advisors[0].name }}
                    </li>
                    <li :class="advisors[0].lastName ? 'done' : 'required'">
                      <b>نام خانوادگی:</b> {{ advisors[0].lastName }}
                    </li>
                    <li :class="advisors[0].mobile ? 'done' : 'required'">
                      <b>تلفن همراه:</b> {{ advisors[0].mobile }}
                    </li>

                    <li :class="advisors[0].email ? 'done' : 'required'">
                      <b>پست الکترونیکی:</b> {{ advisors[0].email }}
                    </li>
                    <li :class="advisors[0].position ? 'done' : 'required'">
                      <b>سمت:</b> {{ advisors[0].position }}
                    </li>
                    <li
                      :class="advisors[0].universityOther ? 'done' : 'required'"
                    >
                      <b>دانشگاه محل تحصیل:</b>
                      {{ advisors[0].universityOther }}
                    </li>
                    <li :class="advisors[0].lastDegree ? 'done' : 'required'">
                      <b>آخرین مدرک تحصیلی:</b>
                      {{ advisors[0].lastDegree }}
                    </li>
                    <li
                      :class="
                        advisors[0].universityJobOther ? 'done' : 'required'
                      "
                    >
                      <b>دانشگاه محل اشتغال:</b>
                      {{ advisors[0].universityJobOther }}
                    </li>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-6 variant="warning">
                <h5 class="mb-0" style="display: inline-block">
                  زمان‌بندی دوره
                </h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-6"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="p-3">
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="request.gantData"
                    :fields="timeFields"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                  </b-table>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-7 variant="dark">
                <h5 class="mb-0" style="display: inline-block">تعهدات</h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-7"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text class="p-3">
                  <b-form-group disabled>
                    <b-form-checkbox
                      :class="request.promiseArrays[0] ? 'done' : 'required'"
                      v-model="request.promiseArrays[0]"
                    >
                      این دوره در مدت زمان اعلام شده انجام می‌گردد و مسئولیت
                      تاخیر در انجام دوره بر عهده مجری می‌باشد. مدت زمان:
                      {{
                        request.gantData.length > 0
                          ? (Math.max(
                              ...request.gantData.map((x) =>
                                new Date(
                                  moment(x.returnDate, "jYYYY/jMM/jDD").format(
                                    "YYYY-MM-DD"
                                  )
                                ).getTime()
                              )
                            ) -
                              Math.min(
                                ...request.gantData.map((x) =>
                                  new Date(
                                    moment(
                                      x.dispatchDate,
                                      "jYYYY/jMM/jDD"
                                    ).format("YYYY-MM-DD")
                                  ).getTime()
                                )
                              )) /
                              3600 /
                              24 /
                              1000 +
                            " روز"
                          : ""
                      }}
                    </b-form-checkbox>
                    <!-- <b-form-checkbox
                :class="promises.p2 ? 'done' : 'required'"
                v-model="promises.p2"
              >
                این طرح با بودجه اعلام شده در پروپوزال انجام می‌گردد. هزینه
                انجام:
                {{
                  (
                    parseInt(
                      PersonnelCostItem.length == 0
                        ? 0
                        : PersonnelCostItem.map(
                            x =>
                              parseInt(x.perPersonCost) *
                              parseInt(x.cooperationHour)
                          ).reduce((a, b) => parseInt(a) + parseInt(b), 0)
                    ) +
                    parseInt(
                      tripCostItem.length == 0
                        ? 0
                        : tripCostItem
                            .map(x => x.cost)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                    ) +
                    parseInt(
                      otherCostItem.length == 0
                        ? 0
                        : otherCostItem
                            .map(x => x.totalPrice)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                    ) +
                    parseInt(
                      OrgCostItem.length == 0
                        ? 0
                        : OrgCostItem.map(x => x.totalPrice).reduce(
                            (a, b) => parseInt(a) + parseInt(b),
                            0
                          )
                    ) +
                    parseInt(
                      deviceCostItem.length == 0
                        ? 0
                        : deviceCostItem
                            .map(x => x.totalPrice)
                            .reduce((a, b) => parseInt(a) + parseInt(b), 0)
                    )
                  ).toLocaleString()
                }}
                ریال
              </b-form-checkbox> -->
                    <b-form-checkbox
                      :class="request.promiseArrays[2] ? 'done' : 'required'"
                      v-model="request.promiseArrays[2]"
                      >توافق بین دانشگاه و صنعت در خصوص دستاوردهای دوره وجود
                      دارد.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="request.promiseArrays[3] ? 'done' : 'required'"
                      v-model="request.promiseArrays[3]"
                      >کلیه اصلاحات در موعد مقرر و طی 2 هفته توسط اینجانب انجام
                      و در سایت بارگذاری می‌گردد.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="request.promiseArrays[4] ? 'done' : 'required'"
                      v-model="request.promiseArrays[4]"
                      >دستاوردهای دوره مشخص است و مستندات ارائه شده
                      است.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="request.promiseArrays[5] ? 'done' : 'required'"
                      v-model="request.promiseArrays[5]"
                    >
                      بهره‌بردار نهایی دستاوردهای دوره مشخص است و مستندات ارائه
                      شده است. <span v-if="request.commercializingType != 'none'">
                    نام بهره‌بردار:
                    <span v-if="request.commercializingType == 'company'">{{
                      request.companyId == notCompany
                        ? request.otherCompanyName
                        : request.companyName
                    }}</span>
                    <span v-else>{{
                      request.acceleratorId
                        ? accelerators.filter(
                            (x) => x.id == request.acceleratorId
                          )[0].text
                        : ""
                    }}</span>
                  </span>
                    </b-form-checkbox>
                    <b-form-checkbox
                      :class="request.promiseArrays[6] ? 'done' : 'required'"
                      v-model="request.promiseArrays[6]"
                      >کلیه گزارش‌ها و خروجی‌ها و دستاوردها در پایان دوره به
                      ستاد زیست فناوری ارسال و تحویل داده
                      می‌شود.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="request.promiseArrays[7] ? 'done' : 'required'"
                      v-model="request.promiseArrays[7]"
                      >ثبت اطلاعات در سامانه هیچ تعهدی را برای ستاد ایجاد
                      نمی‌کند و به منزله ثبت درخواست متقاضی
                      است.</b-form-checkbox
                    >

                    <b-form-checkbox
                      :class="request.promiseArrays[8] ? 'done' : 'required'"
                      v-model="request.promiseArrays[8]"
                      >پروپوزال رساله دکتری اینجانب مصوب شده
                      است.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="request.promiseArrays[9] ? 'done' : 'required'"
                      v-model="request.promiseArrays[9]"
                      >امتحان جامع با موفقیت سپری شده است</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="request.promiseArrays[10] ? 'done' : 'required'"
                      v-model="request.promiseArrays[10]"
                    >
                      میزان شاخص (Hindex) اینجانب صحت دارد</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="request.promiseArrays[11] ? 'done' : 'required'"
                      v-model="request.promiseArrays[11]"
                      >دعوتنامه معتبر از کشور مقصد دریافت شده
                      است.</b-form-checkbox
                    >
                    <b-form-checkbox
                      :class="request.promiseArrays[12] ? 'done' : 'required'"
                      v-model="request.promiseArrays[12]"
                      >کلیه موارد فوق مورد تایید اینجانب
                      {{
                        (request.researcherName ? request.researcherName : '-') +
                        " " +
                        request.researcherLastName
                      }}
                      به عنوان متقاضی و اساتید راهنما می‌باشد.</b-form-checkbox
                    >
                  </b-form-group>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-tab>
        <b-tab title="اطلاعات تجاری‌سازی">
          <v-row class="mb-3">
            <v-col md="6" cols="12">
              <h4 class="c-dark mt-2">
                نوع تجاری‌سازی:
                {{
                  request.commercializingType == "company"
                    ? "شرکت دانش بنیان"
                    : request.commercializingType == "accelerator"
                    ? "شتاب‌دهنده"
                    : "فاقد اطلاعات تجاری‌سازی می‌باشد"
                }}
              </h4>
            </v-col>
          </v-row>
          <b-card-body>
            <b-card-text>
              <ul v-if="request.commercializingType == 'company'">
                <div v-if="request.companyId != notCompany">
                  <li>
                    <strong class="text-primary">نام شرکت دانش بنیان: </strong
                    >{{ request.companyName }}
                  </li>
                  <li>
                    <strong class="text-primary">شماره ثبت شرکت: </strong
                    >{{
                      request.companyRegistrationNumber
                        ? request.companyRegistrationNumber
                        : "-"
                    }}
                  </li>
                  <li>
                    <strong class="text-primary">شناسه ملی شرکت: </strong
                    >{{
                      request.companyNationalId
                        ? request.companyNationalId
                        : "-"
                    }}
                  </li>
                </div>
                <div v-else>
                  <li>
                    <strong class="text-primary">نام شرکت دانش بنیان: </strong
                    >{{ request.otherCompanyName }}
                  </li>
                  <li>
                    <strong class="text-primary">شماره ثبت شرکت: </strong
                    >{{ request.otherCompanyRegistrationNumber }}
                  </li>
                  <li>
                    <strong class="text-primary">شناسه ملی شرکت: </strong
                    >{{ request.otherCompanyNationalId }}
                  </li>
                </div>
                <li>
                  <strong class="text-primary"
                    >معرفی فناوری یا محصولات شرکت: </strong
                  >{{ request.companyProducts }}
                </li>
                <li>
                  <strong class="text-primary"
                    >آدرس پستی / شماره تماس/ پست الکترونیک شرکت: </strong
                  >{{ request.companyContactInfo }}
                </li>
                <li>
                  <strong class="text-primary">توضیحات: </strong
                  >{{ request.companyDescription }}
                </li>
              </ul>
              <ul v-else-if="request.commercializingType == 'accelerator'">
                <li>
                  <strong class="text-primary">نام شتاب‌دهنده:</strong>

                  {{ request.acceleratorName }}
                </li>
              </ul>
              <div v-else-if="request.commercializingType == 'none'">
                <div class="d-flex flex-row mb-2">
                  <b-form-checkbox
                    disabled
                    v-model="request.commercializingObligation1"
                    @change="reactivity = !reactivity"
                  ></b-form-checkbox
                  ><span class="ps-2">
                    تایید میکنم با انتخاب این گزینه تا قبل از تایید درخواست توسط
                    یکی از شتاب‌دهنده‌ها یا شرکت‌های مجاز، ستاد توسعه زیست
                    فناوری هیچگونه مسئولیتی در قبال درخواست من نخواهد داشت.
                  </span>
                </div>
                <div class="d-flex flex-row mb-2">
                  <b-form-checkbox
                    disabled
                    v-model="request.commercializingObligation2"
                    @change="reactivity = !reactivity"
                  ></b-form-checkbox>
                  <span class="ps-2">
                    تایید میکنم با انتخاب این گزینه، کلیه اطلاعات شخصی و علمی
                    این درخواست، در اختیار شتاب‌دهنده‌ها و شرکت‌های مجاز قرار
                    خواهد گرفت تا بتوانند با بررسی اطلاعات، درخواست بنده را
                    بررسی و تایید کنند.
                  </span>
                </div>
              </div>
            </b-card-text>
          </b-card-body>
        </b-tab>
        <b-tab title="فایل های تکمیلی">
          <h6>
            <b-input-group size="md">
              <b-form-input
                trim
                v-model="fileFilter"
                type="search"
                id="filterInput"
                placeholder="جستجو"
              ></b-form-input>
              <b-input-group-append>
                <!-- NOTE (b-delete) to delete the text of the search bar -->
                <b-button
                  :disabled="!fileFilter"
                  @click="fileFilter = ''"
                  variant="danger"
                  >حذف</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </h6>

          <!-- NOTE (t-files) to show the proposal files -->
          <b-table
            responsive
            show-empty
            head-variant="dark"
            :fields="fileFields"
            :items="request.uploadedFiles.filter((x) => x && x.url != '')"
            :filter="fileFilter"
            empty-text="فایلی وجود ندارد"
            striped
            :busy="fileBusy"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(url)="data">
              <div style="text-align: center; vertical-align: middle">
                <!-- NOTE (<a>) to download the uploaded files by opening a new page -->
                <a
                  v-if="data.value"
                  class="btn btn-success"
                  :href="data.value"
                  target="_blank"
                  >دریافت فایل</a
                >
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 }}
              </div>
            </template>
            <div slot="table-busy" class="text-center text-danger my-2">
              <strong class="text-primary">در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
        </b-tab>
        <b-tab v-if="role == 'admin'" title="تاریخچه">
          <div v-if="!projectControl.history.length">
            <h4 text-variant="dark">
              تاریخچه‌ای برای این کنترل پروژه وجود ندارد.
            </h4>
          </div>
          <b-card
            :bg-variant="computedVariant(index)"
            v-for="(p, index) in projectControl.history"
            :key="index"
            style="max-width: 80%"
            class="mb-3 border-0"
          >
            <template slot="header">
              <b-row>
                <b-col>
                  <h5>{{ p.name }}</h5>
                </b-col>
                <b-col>
                  <div style="float: left">
                    <h5>{{ p.date }}</h5>
                  </div>
                </b-col>
              </b-row>
            </template>
            <h6>{{ p.message }}</h6>
          </b-card>
        </b-tab>
        <!--<b-tab v-if="role == 'referee'" title="تاریخچه">
          <b-card
            :bg-variant="computedVariant(index)"
            v-for="(p, index) in computedRefereeJournals"
            :key="index"
            style="max-width: 80%"
            class="mb-3 border-0  "
          >
            <template slot="header">
              <b-row>
                <b-col>
                  <h5>{{ p.name }}</h5>
                </b-col>
                <b-col>
                  <div style="float: left">
                    <h5>{{ p.date }}</h5>
                  </div>
                </b-col>
              </b-row>
            </template>
            <h6>{{ p.message }}</h6>
          </b-card>
        </b-tab>-->
        <b-tab v-if="role == 'admin'" title="کنترل پروژه" active lazy>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-201 variant="dark">
                <h5 class="mb-0">مدیریت وضعیت&nbsp;</h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-201"
              accordion="my-accordion"
              role="tabpanel"
              visible
            >
              <b-card-body>
                <b-card-text>
                  <div v-show="!editClick" class="animated fadeIn">
                    <b-card header-bg-variant="default" class="border-0">
                      <div class="d-flex mb-3" style="float: left">
                        <v-btn
                          class="bc-purple white--text"
                          @click="editClick = true"
                          elevation="0"
                        >
                          <v-icon class="me-2">mdi-pencil-outline</v-icon>
                          ویرایش
                        </v-btn>
                      </div>
                      <h3 class="m-auto ml-3">وضعیت قرارداد</h3>
                      <br />
                      <div class="ms-6">
                        <span
                          class="text-dark h5"
                          v-if="projectControl.contract"
                          >کنترل پروژه شامل قرارداد می‌شود.</span
                        >
                        <span
                          class="text-dark h5"
                          v-else-if="!projectControl.contract"
                          >کنترل پروژه شامل قرارداد نمی‌شود.</span
                        >
                      </div>
                      <div
                        class="ms-6 mt-4"
                        v-if="
                          projectControl.contract &&
                          !projectControl.contractFileId
                        "
                      >
                        فایل قرارداد هنوز بارگذاری نشده ‌است.
                      </div>
                      <div
                        class="ms-6 mt-4"
                        v-if="
                          projectControl.contract &&
                          projectControl.contractFileId
                        "
                      >
                        <span class="text-dark h6 font-weight-bold">
                          <v-icon class="primary--text"
                            >mdi-download-circle-outline</v-icon
                          >
                          قرارداد بارگذاری شده:
                        </span>
                        <a
                          :href="projectControl.contractFile"
                          target="blank"
                          v-if="projectControl.contractFile"
                        >
                          دانلود</a
                        >
                      </div>
                      <b-row class="mt-4">
                        <b-col cols="6"
                          ><h3 class="text-center">وضعیت کلی</h3>
                          <b-form-group disabled>
                            <b-form-input
                              v-model="projectControl.status"
                              class="text-center"
                              style="font-size: 1.3em"
                            >
                            </b-form-input>
                          </b-form-group>
                        </b-col>

                        <b-col cols="6">
                          <h3 class="text-center">ناظر مربوطه</h3>
                          <b-form-group disabled>
                            <b-form-input
                              class="text-center"
                              v-model="computedReviewer"
                              style="font-size: 1.3em"
                            ></b-form-input> </b-form-group></b-col
                      ></b-row>
                      <b-form-group label="یادداشت برای پژوهشگر:">
                        <b-form-textarea
                          disabled
                          class="myselect2"
                          v-model="projectControl.adminMessage"
                          style="font-size: 1.3em"
                          v-if="projectControl.adminMessage != ''"
                        >
                        </b-form-textarea>
                        <div v-else class="diabled-textarea">
                          <span style="font-size: 1.3em">--</span>
                        </div>
                      </b-form-group>
                      <div
                        v-if="
                          request.commercializingType == 'accelerator' &&
                          projectControl.isAccelerator
                        "
                        class="my-4"
                      >
                        <v-icon class="me-2 primary--text"
                          >mdi-alert-circle-outline</v-icon
                        >
                        <span class="h5 text-dark"
                          >گزارش‌ها نیاز به تایید شتاب دهنده دارند.</span
                        >
                      </div>
                    </b-card>
                  </div>

                  <div v-show="editClick" class="animated fadeIn">
                    <b-card header-bg-variant="default" class="border-0"
                      ><template v-slot:header class="border-0">
                        <h4 class="text-center">ویرایش گزارش</h4>
                      </template>
                      <v-row class="mb-3" style="float: left">
                        <v-col
                          ><v-btn
                            class="bc-purple white--text btn"
                            @click="editClick = false"
                            elevation="0"
                          >
                            بازگشت
                            <v-icon class="ms-2">mdi-keyboard-backspace</v-icon>
                          </v-btn></v-col
                        >
                      </v-row>
                      <div class="mt-10">
                        <div class="d-flex">
                          <h4 class="text-dark">قرارداد</h4>
                          <v-icon
                            v-if="!editContract"
                            @click="
                              editContract = true;
                              editProjectControl = JSON.parse(
                                JSON.stringify(projectControl)
                              );
                            "
                            class="mb-4 ms-2"
                            >$Edit</v-icon
                          >
                        </div>

                        <div>
                          <div v-if="editContract" class="mb-12">
                            <b-form-radio-group
                              v-model="editProjectControl.contract"
                            >
                              <div class="d-flex contract-section" dir="rtl">
                                <b-form-radio :value="true"></b-form-radio>
                                <label class="ml-2 mt-1"
                                  ><h6>شامل قرارداد می‌شود</h6></label
                                >
                              </div>
                              <div class="d-flex contract-section" dir="rtl">
                                <b-form-radio :value="false"></b-form-radio>
                                <label class="ml-2 mt-1"
                                  ><h6>شامل قرارداد نمی‌شود</h6></label
                                >
                              </div>
                            </b-form-radio-group>
                            <v-btn
                              class="red lighten-1 white--text ms-2 float-end"
                              @click="editContract = false"
                              elevation="0"
                            >
                              <v-icon small class="me-1"
                                >mdi-close-outline</v-icon
                              >
                              لغو</v-btn
                            >
                            <v-btn
                              class="bc-primary white--text ms-2 float-end"
                              @click="contractStatus()"
                              elevation="0"
                            >
                              <v-icon small class="me-1"
                                >mdi-check-outline</v-icon
                              >
                              ثبت</v-btn
                            >
                          </div>
                          <div v-if="!editContract">
                            <h6 class="text-dark">
                              {{
                                projectControl.contract
                                  ? "گزارش شامل قرارداد می‌شود."
                                  : "گزارش شامل قرارداد نمی‌شود."
                              }}
                            </h6>
                          </div>
                        </div>
                      </div>

                      <hr />

                      <div>
                        <div class="d-flex">
                          <h4 class="text-dark">وضعیت کلی</h4>
                          <v-icon
                            v-if="!editStatus"
                            @click="
                              editStatus = true;
                              editProjectControl = JSON.parse(
                                JSON.stringify(projectControl)
                              );
                            "
                            class="mb-4 ms-2"
                            >$Edit</v-icon
                          >
                        </div>
                        <div v-if="editStatus" class="mb-14">
                          <b-form-group class="mb-4">
                            <b-form-select
                              v-model="editProjectControl.status"
                              :options="statusOpt"
                            >
                            </b-form-select>
                          </b-form-group>
                          <v-btn
                            class="red lighten-1 white--text ms-2 float-end"
                            @click="editStatus = false"
                            elevation="0"
                          >
                            <v-icon small class="me-1"
                              >mdi-close-outline</v-icon
                            >
                            لغو</v-btn
                          >
                          <v-btn
                            class="bc-primary white--text ms-2 float-end"
                            @click="editProjectStatus()"
                            elevation="0"
                          >
                            <v-icon small class="me-1"
                              >mdi-check-outline</v-icon
                            >
                            ثبت</v-btn
                          >
                        </div>
                        <div v-if="!editStatus">
                          <div
                            :class="
                              projectControl.status == 'درحال انجام'
                                ? 'blue-badge'
                                : projectControl.status == 'اختتام ناقص'
                                ? 'pink-badge'
                                : projectControl.status == 'اتمام'
                                ? 'green-badge'
                                : 'orange-badge'
                            "
                          >
                            <h6 class="my-1">
                              {{ projectControl.status }}
                            </h6>
                          </div>
                        </div>
                      </div>
                      <hr />
                      <div>
                        <div class="d-flex">
                          <h4 class="text-dark">ناظر</h4>
                          <v-icon
                            v-if="!editReferee"
                            @click="
                              editReferee = true;
                              editProjectControl = JSON.parse(
                                JSON.stringify(projectControl)
                              );
                            "
                            class="mb-4 ms-2"
                            >$Edit</v-icon
                          >
                        </div>
                        <div v-if="editReferee" class="mb-12">
                          <v-switch
                            v-model="editProjectControl.isReferee"
                            :label="`گزارش‌ها نیاز به نظارت ناظر دارند.`"
                          ></v-switch>
                          <Select2
                            v-if="editProjectControl.isReferee"
                            class="myselect2 mb-2"
                            v-model="reviewersData"
                            :options="reviewersFields"
                            :settings="{ width: '100%' }"
                          ></Select2>

                          <v-btn
                            class="red lighten-1 white--text ms-2 float-end"
                            @click="editReferee = false"
                            elevation="0"
                          >
                            <v-icon small class="me-1"
                              >mdi-close-outline</v-icon
                            >
                            لغو</v-btn
                          >
                          <v-btn
                            class="bc-primary white--text ms-2 float-end"
                            @click="editProjectReferee()"
                            :disabled="
                              editProjectControl.isReferee && !reviewersData
                            "
                            elevation="0"
                          >
                            <v-icon small class="me-1"
                              >mdi-check-outline</v-icon
                            >
                            ثبت</v-btn
                          >
                        </div>
                        <div v-if="!editReferee">
                          <h6 class="text-dark">
                            {{
                              projectControl.isReferee
                                ? " گزارش‌ها تحت نظارت " +
                                  computedReviewer +
                                  " هستند. "
                                : "گزارش‌ها نیاز به نظارت ناظر ندارند."
                            }}
                          </h6>
                        </div>
                      </div>

                      <hr />
                      <div v-if="request.commercializingType == 'accelerator'">
                        <div class="d-flex">
                          <h4 class="text-dark">شتاب‌دهنده</h4>
                          <v-icon
                            v-if="!editAccelerator"
                            @click="
                              editAccelerator = true;
                              editProjectControl = JSON.parse(
                                JSON.stringify(projectControl)
                              );
                            "
                            class="mb-4 ms-2"
                            >$Edit</v-icon
                          >
                        </div>
                        <div v-if="editAccelerator" class="mb-12">
                          <v-switch
                            v-model="editProjectControl.isAccelerator"
                            :label="`گزارش‌ها نیاز به تایید شتاب‌دهنده دارند.`"
                          ></v-switch>
                          <v-btn
                            class="red lighten-1 white--text ms-2 float-end"
                            @click="editAccelerator = false"
                            elevation="0"
                          >
                            <v-icon small class="me-1"
                              >mdi-close-outline</v-icon
                            >
                            لغو</v-btn
                          >
                          <v-btn
                            class="bc-primary white--text ms-2 float-end"
                            @click="editProjectAccelerator()"
                            elevation="0"
                          >
                            <v-icon small class="me-1"
                              >mdi-check-outline</v-icon
                            >
                            ثبت</v-btn
                          >
                        </div>
                        <div v-if="!editAccelerator">
                          <h6 class="text-dark">
                            {{
                              projectControl.isAccelerator
                                ? "گزارش‌ها نیاز به تایید شتاب‌دهنده دارند."
                                : "گزارش‌ها نیاز به تایید شتاب‌دهنده ندارند."
                            }}
                          </h6>
                        </div>
                      </div>
                      <hr v-if="request.commercializingType == 'accelerator'" />
                      <div>
                        <div class="d-flex">
                          <h4 class="text-dark">یادداشت برای پژوهشگر</h4>
                          <v-icon
                            v-if="!editMessage"
                            @click="
                              editMessage = true;
                              editProjectControl = JSON.parse(
                                JSON.stringify(projectControl)
                              );
                            "
                            class="mb-4 ms-2"
                            >$Edit</v-icon
                          >
                        </div>
                        <div v-if="editMessage" class="mb-14">
                          <b-form-group class="mb-2">
                            <b-form-textarea
                              v-model="editProjectControl.adminMessage"
                            >
                            </b-form-textarea>
                          </b-form-group>
                          <v-btn
                            class="red lighten-1 white--text ms-2 float-end"
                            @click="editMessage = false"
                            elevation="0"
                          >
                            <v-icon small class="me-1"
                              >mdi-close-outline</v-icon
                            >
                            لغو</v-btn
                          >
                          <v-btn
                            class="bc-primary white--text ms-2 float-end"
                            @click="editProjectMessage()"
                            elevation="0"
                          >
                            <v-icon small class="me-1"
                              >mdi-check-outline</v-icon
                            >
                            ثبت</v-btn
                          >
                        </div>
                        <div v-if="!editMessage">
                          <p class="text-dark text-justify">
                            {{
                              projectControl.adminMessage
                                ? projectControl.adminMessage
                                : "یادداشتی ثبت نشده است."
                            }}
                          </p>
                        </div>
                      </div>
                      <hr />

                      <h4 class="text-center text-dark">افزودن گزارش جدید‌</h4>

                      <!--<b-button
                        variant="success"
                        class="mb-3 ml-1"
                        @click="addReport()"
                        ><strong>افزودن +</strong></b-button
                      >
                      <b-table
                        responsive
                        small
                        show-empty
                        head-variant="light"
                        :items="reportItems"
                        :fields="reportFields"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.index + 1 }}
                          </div>
                        </template>

                        <template v-slot:cell(name)="data">
                          <b-form-input
                            trim
                            v-model="data.item.name"
                            type="text"
                          ></b-form-input> </template><template v-slot:cell(date)="data">
                          <datePicker
                            color="#7b1fa2"
                            v-model="data.item.date"
                          ></datePicker>
                        </template>
                        <template v-slot:cell(operation)="data">
                          <b-button
                            variant="danger"
                            class="mr-2"
                            @click="removeReport(data.index)"
                            >x</b-button
                          >
                        </template>
                      </b-table>-->
                      <v-row>
                        <b-col>
                          <b-form-group label="عنوان گزارش">
                            <b-form-input
                              trim
                              type="text"
                              v-model="newReportSubject"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col>
                          <b-form-group label="تاریخ گزارش">
                            <date-picker
                              color="#7b1fa2"
                              v-model="newReportDate"
                            ></date-picker>
                          </b-form-group>
                        </b-col>
                      </v-row>
                      <v-btn
                        class="bc-primary white--text ms-2 mt-3 float-end"
                        @click="submitNewReports()"
                        elevation="0"
                        :disabled="!newReportSubject || !newReportDate"
                      >
                        <v-icon small class="me-1"
                          >mdi-checkbox-marked-circle-plus-outline</v-icon
                        >
                        ثبت گزارش</v-btn
                      >
                    </b-card>
                  </div>
                  <hr />
                  <b-card header-bg-variant="default" class="border-0">
                    <h3 class="text-center">گزارش‌‌ها</h3>
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="adminReportsItems"
                      :fields="reportsFields"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                      :busy="tableBusy"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                      <template v-slot:cell(operation)="data">
                        <!-- NOTE (b-delAvhievment) to remove a row from achievment items table -->
                        <div
                          style="
                            text-align: center;
                            vertical-align: middle;
                            width: 150px;
                            margin: auto;
                          "
                        >
                          <b-button
                            variant="primary"
                            class="btn"
                            style="width: 100%"
                            @click="showModal(data.item, data.index)"
                            >جزییات</b-button
                          >
                        </div>
                      </template>
                      <div
                        slot="table-busy"
                        class="text-center text-danger my-2"
                      >
                        <strong class="text-primary">در حال بارگذاری...</strong>
                        <br />
                        <b-spinner class="align-middle"></b-spinner>
                      </div>
                    </b-table>
                  </b-card>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-202 variant="light">
                <h5 class="mb-0">مدیریت فایل‌ها&nbsp;</h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-202"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text>
                  <b-card header-bg-variant="default" class="border-0">
                    <template v-slot:header class="border-0">
                      <h4 class="text-center white--text">فایل‌ها</h4>
                    </template>
                    <b-row>
                      <b-col>
                        <b-form-input
                          trim
                          v-model="addFile.fileName"
                          placeholder="نام فایل"
                          type="text"
                        ></b-form-input>
                      </b-col>
                      <b-col>
                        <datePicker
                          color="#7b1fa2"
                          v-model="addFile.fileDate"
                        ></datePicker>
                      </b-col>
                      <b-col>
                        <b-button
                          @click="adminAddFile()"
                          variant="primary"
                          :disabled="!addFile.fileName || !addFile.fileDate"
                          >افزودن فایل</b-button
                        >
                      </b-col>
                    </b-row>
                    <br />
                    <b-table
                      responsive
                      small
                      show-empty
                      head-variant="dark"
                      :items="adminFilesItems"
                      :fields="adminFilesFields"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                      :busy="tableBusy"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + 1 }}
                        </div>
                      </template>
                      <template v-slot:cell(operation)="data">
                        <div
                          style="
                            text-align: center;
                            vertical-align: middle;
                            width: 150px;
                            margin: auto;
                          "
                        >
                          <a
                            v-if="data.item.file.length"
                            class="btn btn-success"
                            :href="data.item.file"
                            target="_blank"
                            >دریافت</a
                          >
                          <div v-if="!data.item.file.length">
                            <b-button
                              variant="danger"
                              @click="adminDelFile(data.index)"
                              >حذف فایل</b-button
                            >
                          </div>
                        </div>
                      </template>
                      <div
                        slot="table-busy"
                        class="text-center text-danger my-2"
                      >
                        <strong class="text-primary">در حال بارگذاری...</strong>
                        <br />
                        <b-spinner class="align-middle"></b-spinner>
                      </div>
                    </b-table>
                    <div class="mt-3">
                      تذکر: شما فقط زمانی قابلیت حذف فیلد فایلی را دارید که
                      پژوهشگر فایلی در آن آپلود نکرده باشد.
                    </div>
                    <b-button
                      :disabled="newReportBusy"
                      block
                      variant="success"
                      size="md"
                      class="mt-3"
                      @click="editFiles()"
                      >ثبت</b-button
                    >
                  </b-card>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-tab>
        <b-tab v-if="role == 'researcher'" title="کنترل پروژه" active>
          <b-card v-if="projectControl.contract" no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-101 variant="dark">
                <h5 class="mb-0">بارگذاری قرارداد&nbsp;</h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-101"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text>
                  <div>
                    <div>
                      <b-form-group>
                        <b-form-file
                          :state="Boolean(projectControl.contractFile)"
                          @input="researcherContractUpload(resContractFile)"
                          v-model="resContractFile"
                          browse-text="بارگذاری"
                          :disabled="projectControl.status != 'درحال انجام'"
                          :placeholder="
                            projectControl.contractFile
                              ? projectControl.contractFile
                              : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                          "
                        ></b-form-file>
                      </b-form-group>

                      <b-form-group>
                        <b-col>
                          <b-progress
                            v-if="Boolean(myFile.showProgress)"
                            :value="myFile.uploadPercentage"
                            :max="max"
                            show-progress
                            :animated="myFile.striped"
                            :variant="myFile.variant"
                          ></b-progress>
                        </b-col>
                      </b-form-group>
                    </div>

                    <div
                      v-if="projectControl.contractFile"
                      style="text-align: center; vertical-align: middle"
                      class="mt-2"
                    >
                      <hr
                        class="m-auto mb-5"
                        v-if="projectControl.status == 'درحال انجام'"
                      />
                      <h4 class="text-dark">فایل‌ قرارداد</h4>
                      <a
                        class="btn btn-success"
                        :href="projectControl.contractFile"
                        target="_blank"
                        >دریافت فایل</a
                      >
                    </div>
                  </div>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-102 variant="dark">
                <h5 class="mb-0">
                  وضعیت کنترل پروژه: {{ projectControl.status }} &nbsp;
                </h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-102"
              accordion="my-accordion"
              role="tabpanel"
              visible
            >
              <b-card-body>
                <b-card-text>
                  <h4 class="text-dark">گزارش‌‌ها</h4>
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="reports"
                    :fields="reportsFields"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:cell(operation)="data">
                      <!-- NOTE (b-delAvhievment) to remove a row from achievment items table -->
                      <div
                        style="
                          text-align: center;
                          vertical-align: middle;
                          width: 150px;
                          margin: auto;
                        "
                      >
                        <b-button
                          v-if="data.item.status == 'ثبت شده'"
                          variant="warning"
                          class="btn mb-1"
                          @click="showResearcherModal(data.item, data.index)"
                          :disabled="projectControl.status != 'درحال انجام'"
                          >بارگذاری گزارش</b-button
                        >
                        <b-button
                          v-if="
                            (data.item.status == 'ثبت شده' &&
                              projectControl.status == 'اتمام') ||
                            projectControl.status == 'اختتام ناقص' ||
                            projectControl.status ==
                              'پذیرش علمی-در انتظار ادمین'
                          "
                          variant="primary"
                          class="btn mt-1"
                          @click="showResearcherView(data.item, data.index)"
                          >مشاهده گزارش</b-button
                        >
                        <b-button
                          v-else
                          variant="primary"
                          class="btn"
                          @click="showResearcherView(data.item, data.index)"
                          >مشاهده گزارش</b-button
                        >
                        <b-button
                          v-if="data.item.status == 'نیازمند اصلاح'"
                          variant="success"
                          class="btn mt-1"
                          @click="showResearcherModal(data.item, data.index)"
                          :disabled="projectControl.status != 'درحال انجام'"
                          >ارسال اصلاحیه</b-button
                        >
                      </div>
                    </template>
                  </b-table>
                  <br />
                  <hr />
                  <h4 class="text-dark">فایل گزارش‌ها</h4>
                  <b-table
                    responsive
                    show-empty
                    head-variant="dark"
                    :fields="reportFileFields"
                    :items="computedReportFiles"
                    :filter="fileFilter"
                    empty-text="فایلی وجود ندارد"
                    striped
                    :busy="fileBusy"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(url)="data">
                      <div style="text-align: center; vertical-align: middle">
                        <!-- NOTE (<a>) to download the uploaded files by opening a new page -->
                        <a
                          v-if="data.value"
                          class="btn btn-success"
                          :href="data.value"
                          target="_blank"
                          >دریافت فایل</a
                        >
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <div slot="table-busy" class="text-center text-danger my-2">
                      <strong class="text-primary">در حال بارگذاری...</strong>
                      <br />
                      <b-spinner class="align-middle"></b-spinner>
                    </div>
                  </b-table>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.accordion-103 variant="dark">
                <h5 class="mb-0">بارگذاری فایل &nbsp;</h5>
              </b-button>
            </b-card-header>
            <b-collapse
              id="accordion-103"
              accordion="my-accordion"
              role="tabpanel"
            >
              <b-card-body>
                <b-card-text>
                  <b-table
                    responsive
                    small
                    show-empty
                    head-variant="dark"
                    :items="researcherFileItems"
                    :fields="researcherFileFields"
                    empty-text="رکوردی برای نمایش وجود ندارد"
                    class="table table-secondary"
                  >
                    <template v-slot:head()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.label }}
                      </div>
                    </template>
                    <template v-slot:cell()="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.value }}
                      </div>
                    </template>
                    <template v-slot:cell(index)="data">
                      <div style="text-align: center; vertical-align: middle">
                        {{ data.index + 1 }}
                      </div>
                    </template>
                    <template v-slot:cell(upload)="row">
                      <div style="text-align: center; vertical-align: middle">
                        <b-button
                          v-if="row.item._showDetails"
                          variant="primary"
                          @click="row.toggleDetails"
                          >بستن
                        </b-button>
                        <b-button
                          v-else
                          variant="warning"
                          @click="row.toggleDetails"
                          >{{ row.item.fileId ? "مشاهده/ ویرایش" : "بارگذاری" }}
                        </b-button>
                      </div>
                    </template>
                    <template #row-details="row">
                      <b-card>
                        <b-form-group row.index>
                          <b-form-file
                            :state="Boolean(row.item.file)"
                            :disabled="
                              Boolean(myPcFile[row.index].isUploaded) ||
                              projectControl.status != 'درحال انجام'
                            "
                            @input="
                              researcherUpload(
                                pcUploadedFiles[row.index],
                                row.index
                              )
                            "
                            v-model="pcUploadedFiles[row.index]"
                            browse-text="بارگذاری"
                            :placeholder="
                              row.item.fileId
                                ? row.item.file
                                : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                            "
                          ></b-form-file>
                        </b-form-group>

                        <b-form-group>
                          <b-col>
                            <b-progress
                              v-if="Boolean(myPcFile[row.index].showProgress)"
                              :value="myPcFile[row.index].uploadPercentage"
                              :max="max"
                              show-progress
                              :animated="myPcFile[row.index].striped"
                              :variant="myPcFile[row.index].variant"
                            ></b-progress>
                            <!--  -->
                            <br />
                            <b-row>
                              <br />
                              <div
                                v-if="myPcFile[row.index].isUploaded"
                                color="green"
                                class="mt-1"
                                style="color: green"
                              >
                                فایل با موفقیت بارگذاری شد.
                              </div>

                              <b-col>
                                <b-row align-h="end">
                                  <span class="ml-2" style="float: left"
                                    ><a
                                      class="btn btn-success"
                                      v-if="row.item.file"
                                      :href="row.item.file"
                                      target="_blank"
                                      >دریافت</a
                                    ></span
                                  >

                                  <b-button
                                    style="height: 35px; float: left"
                                    class="btn ml-2"
                                    v-if="row.item.file"
                                    variant="danger"
                                    @click="
                                      pcUploadedFiles[row.index] = [];
                                      row.item.file = '';
                                      row.item.fileId = null;
                                      myPcFile[row.index].uploadPercentage = 0;
                                      myPcFile[row.index].isUploaded = false;
                                      myPcFile[row.index].showProgress = false;
                                    "
                                    :disabled="
                                      projectControl.status != 'درحال انجام'
                                    "
                                    >حذف</b-button
                                  >
                                </b-row>
                              </b-col>
                            </b-row>
                            <!--  -->
                          </b-col>
                        </b-form-group>
                      </b-card>
                    </template>
                  </b-table>
                  <b-button
                    class="btn mt-3"
                    variant="success"
                    @click="finalUpload()"
                    :disabled="
                      resFileBusy ||
                      !researcherFileItems.length ||
                      projectControl.status != 'درحال انجام'
                    "
                    >بارگذاری نهایی</b-button
                  >
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </b-tab>
        <b-tab v-if="role == 'referee'" title="کنترل پروژه" active>
          <b-card header-bg-variant="default" class="border-0">
            <b-row>
              <b-col cols="6">
                <h4 class="text-center text-dark">عنوان گزارش</h4>
                <b-form-group disabled>
                  <b-form-input
                    v-model="refereeReport.subject"
                    class="text-center"
                    style="font-size: 1.7em"
                  >
                  </b-form-input>
                </b-form-group> </b-col
              ><b-col cols="6">
                <h4 class="text-center text-dark">درصد پیشرفت</h4>
                <b-form-group disabled>
                  <b-form-input
                    class="text-center"
                    v-model="refereeReport.percent"
                    style="font-size: 1.7em"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <h4 class="text-center text-dark">توضیحات</h4>
            <b-form-group disabled>
              <b-form-textarea
                class="text-center"
                v-model="refereeReport.description"
                style="font-size: 1.4em"
              ></b-form-textarea>
            </b-form-group>

            <b-table
              responsive
              small
              show-empty
              head-variant="dark"
              :items="reportFiles"
              :fields="refFileFields"
              empty-text="رکوردی برای نمایش وجود ندارد"
              class="mt-3"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 }}
                </div>
              </template>
              <template v-slot:cell(url)="data">
                <div style="text-align: center; vertical-align: middle">
                  <!-- NOTE (<a>) to download the uploaded files by opening a new page -->
                  <a
                    v-if="data.value"
                    class="btn btn-success"
                    :href="data.value"
                    target="_blank"
                    >دریافت فایل</a
                  >
                </div>
              </template>
            </b-table>

            <b-card header-bg-variant="default" class="border-0">
              <template v-slot:header>
                <h4 class="mb-0 text-center">نظر نهایی</h4>
              </template>
              <br />
              <div class="d-flex justify-content-center mb-3">
                <b-form-radio-group
                  size="lg"
                  v-model="refereeReport.reportJudge"
                >
                  <div class="d-flex justify-content-center mb-3">
                    <div class="d-flex" dir="rtl">
                      <b-form-radio value="approve"></b-form-radio>
                      <label class="ml-2 mt-1"><h5>تایید</h5></label>
                    </div>
                    <div class="d-flex" dir="rtl">
                      <b-form-radio value="reject"></b-form-radio>
                      <label class="ml-2 mt-1"><h5>رد</h5></label>
                    </div>
                  </div>
                </b-form-radio-group>
              </div>
              <div
                v-if="
                  refereeReport.reportJudge == 'approve' ||
                  refereeReport.reportJudge == 'reject'
                "
              >
                <b-row
                  style="
                    border: red solid 1px;
                    padding: 10px;
                    border-radius: 5px;
                    margin: 8px;
                  "
                >
                  <i
                    class="fa fa-exclamation-triangle fa-2x text-warning ml-2"
                    aria-hidden="true"
                  ></i>
                  <p class="mt-2 ml-2 text-danger">
                    تذکر: ناظر محترم، لطفا پس از بررسی دقیق گزارش، میزان پیشرفت
                    را مشخص بفرمایید، دقت نمایید که میزان پیشرفت اعلام شده توسط
                    شما ملاک عمل و نتیجه گیری نهایی خواهد بود
                  </p>
                </b-row>
                <b-form-group
                  label="درصد کل پیشرفت پروژه از ابتدا تا کنون از 100 :"
                  class="mt-3"
                >
                  <b-form-input
                    type="number"
                    :no-wheel="true"
                    min="0"
                    max="100"
                    class="myselect2"
                    @change="over100()"
                    v-model="refereeReport.judgePercent"
                  >
                  </b-form-input>
                </b-form-group>
              </div>
              <div v-if="refereeReport.reportJudge == 'approve'">
                <b-form-group label="توضیحات:">
                  <b-form-textarea
                    class="myselect2"
                    v-model="refereeReport.judgeDescription"
                  >
                  </b-form-textarea>
                </b-form-group>
              </div>
              <div v-if="refereeReport.reportJudge == 'reject'">
                <b-form-group label="دلیل رد:">
                  <b-form-textarea
                    v-model="refereeReport.refereeRejectionCause"
                  >
                  </b-form-textarea>
                </b-form-group>
              </div>
              <div class="d-flex mb-3">
                <b-button
                  :disabled="computedDisable || newReportBusy"
                  variant="success"
                  size="md"
                  @click="addJudgeReport()"
                  >ثبت</b-button
                >
              </div>
            </b-card>
          </b-card>
        </b-tab>
      </b-tabs>
    </b-card>
    <b-modal
      id="report"
      ref="report"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center border-0"
      size="xl"
      centered
    >
      <template v-slot:modal-header class="border-0">
        <h4>جزییات گزارش</h4>
      </template>
      <div v-if="role == 'admin'">
        <h5 class="text-primary">گزارش پژوهشگر</h5>
        <b-table
          responsive
          small
          show-empty
          head-variant="light"
          :items="
            adminReportsItems.filter((x) => x.id == reportSelectedItem.item.id)
          "
          :fields="researcherFields"
          empty-text="رکوردی برای نمایش وجود ندارد"
          class="table table-secondary"
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(percent)="data">
            <div style="text-align: center; vertical-align: middle">
              <span>{{
                data.value == "-" || data.value == "" ? "-" : "%" + data.value
              }}</span>
            </div>
          </template>
          <template v-slot:cell(description)="data">
            <div style="text-align: center; vertical-align: middle">
              <span>{{ data.value ? data.value : "-" }}</span>
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 }}
            </div>
          </template>
          <template v-slot:cell(url)="data">
            <!-- NOTE (b-delAvhievment) to remove a row from achievment items table -->
            <div style="text-align: center; vertical-align: middle">
              <a
                v-if="data.item.file"
                class="btn btn-success mt-1"
                :href="data.item.file"
                target="_blank"
                >دریافت گزارش</a
              >
              <a
                v-if="data.item.financeFile"
                class="ml-2 btn btn-success mt-1"
                :href="data.item.financeFile"
                target="_blank"
                >دریافت درخواست مالی</a
              >
            </div>
            <span v-if="!data.item.file && !data.item.financeFile">-</span>
          </template>
        </b-table>

        <br />
        <hr />
        <h5 class="text-primary">گزارش ناظر</h5>
        <b-table
          responsive
          small
          show-empty
          head-variant="light"
          :items="
            adminReportsItems.filter((x) => x.id == reportSelectedItem.item.id)
          "
          :fields="refereeFields"
          empty-text="رکوردی برای نمایش وجود ندارد"
          class="table table-secondary"
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(judge)="data">
            <div style="text-align: center; vertical-align: middle">
              <span>{{ data.value ? data.value : "-" }}</span>
            </div>
          </template>
          <template v-slot:cell(judgePer)="data">
            <div style="text-align: center; vertical-align: middle">
              <span>{{
                data.value == "-" || data.value == "" ? "-" : "%" + data.value
              }}</span>
            </div>
          </template>
          <template v-slot:cell(refereeId)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value == "" || data.value == " " ? "-" : data.value }}
            </div>
          </template>
          <template v-slot:cell(judgeDescription)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value ? data.value : "-" }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 }}
            </div>
          </template>
        </b-table>
        <br />
        <hr />
        <h5 class="text-primary">گزارش شتاب‌دهنده</h5>
        <b-table
          responsive
          small
          show-empty
          head-variant="light"
          :items="
            adminReportsItems.filter((x) => x.id == reportSelectedItem.item.id)
          "
          :fields="acceleratorFields"
          empty-text="رکوردی برای نمایش وجود ندارد"
          class="table table-secondary"
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(acceleratorStatus)="data">
            <div style="text-align: center; vertical-align: middle">
              <span>{{
                statusDictionary.find((x) => x.en == data.value).fa
              }}</span>
            </div>
          </template>
          <template v-slot:cell(reportAcceleratorDecision)="data">
            <div style="text-align: center; vertical-align: middle">
              <span>{{ data.value ? data.value : "-" }}</span>
            </div>
          </template>
          <template v-slot:cell(reportAcceleratorPerc)="data">
            <div style="text-align: center; vertical-align: middle">
              <span>{{
                data.value == "-" || data.value == "" ? "-" : "%" + data.value
              }}</span>
            </div>
          </template>
          <template v-slot:cell(acceleratorDescription)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value ? data.value : "-" }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 }}
            </div>
          </template>
        </b-table>
        <br />
        <hr />
        <h5 class="text-primary">گزارش مدیر</h5>
        <b-table
          responsive
          small
          show-empty
          head-variant="light"
          :items="
            adminReportsItems.filter((x) => x.id == reportSelectedItem.item.id)
          "
          :fields="adminFields"
          empty-text="رکوردی برای نمایش وجود ندارد"
          class="table table-secondary"
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(adminMessage)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value ? data.value : "-" }}
            </div>
          </template>
          <template v-slot:cell(adminPer)="data">
            <div style="text-align: center; vertical-align: middle">
              <span>{{
                data.value == "-" || data.value == "" ? "-" : "%" + data.value
              }}</span>
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 }}
            </div>
          </template>
        </b-table>
        <br />
        <b-row v-if="adminReportsItems[reportSelectedItem.index]">
          <b-col cols="6">
            <b-form-group label="وضعیت:">
              <b-form-select
                class="myselect2"
                id="first"
                v-model="reportStatus"
                :options="
                  !projectControl.isAccelerator ? options : acceleratorOptions
                "
              >
              </b-form-select>
            </b-form-group> </b-col
          ><b-col cols="6">
            <b-form-group
              label="درصد کل پیشرفت پروژه از ابتدا تا کنون از 100 :"
            >
              <b-form-input
                type="number"
                :no-wheel="true"
                min="0"
                max="100"
                class="myselect2"
                @change="
                  dynamicOver100(
                    'adminReportsItems2',
                    reportSelectedItem.index,
                    'adminPer'
                  )
                "
                v-model="adminReportsItems2[reportSelectedItem.index].adminPer"
              >
              </b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="adminReportsItems[reportSelectedItem.index]">
          <b-col class="pt-0">
            <b-form-group label="توضیحات:">
              <b-form-textarea
                class="myselect2"
                v-model="
                  adminReportsItems2[reportSelectedItem.index].adminMessage
                "
              >
              </b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <template v-slot:modal-footer>
        <b-button
          :disabled="
            newReportBusy ||
            (!projectControl.isAccelerator
              ? options.filter(
                  (x) =>
                    x.text == adminReportsItems[reportSelectedItem.index].status
                )[0].value == 'incompleteFinish'
              : acceleratorOptions.filter(
                  (x) =>
                    x.text == adminReportsItems[reportSelectedItem.index].status
                )[0].value == 'incompleteFinish')
          "
          block
          variant="success"
          size="lg"
          @click="
            adminEditReport(adminReportsItems[reportSelectedItem.index].id)
          "
          >ثبت</b-button
        >
      </template>
    </b-modal>
    <b-modal
      id="researcherReport"
      ref="researcherReport"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center border-0"
      size="lg"
      centered
    >
      <template v-slot:modal-header class="border-0">
        <h4>جزییات گزارش</h4>
      </template>
      <div v-if="role == 'researcher'">
        <b-card class="border-0">
          <b-form-group label="بارگذاری گزارش">
            <b-form-group>
              <b-form-file
                :state="Boolean(reports2[selectedItem.index].file)"
                @input="myReportUpload(reportFile, 0, 'file')"
                v-model="reportFile"
                browse-text="بارگذاری"
                :placeholder="
                  reports2[selectedItem.index].file
                    ? reports2[selectedItem.index].file
                    : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                "
              ></b-form-file>
            </b-form-group>

            <b-form-group>
              <b-col>
                <b-progress
                  v-if="Boolean(myReportFile[0].uploadPercentage)"
                  :value="myReportFile[0].uploadPercentage"
                  :max="max"
                  show-progress
                  :animated="myReportFile[0].striped"
                  :variant="myReportFile[0].variant"
                ></b-progress>
                <b-row>
                  <b-col cols="6">
                    <div
                      v-if="myReportFile[0].isUploaded"
                      color="green"
                      class="mt-3"
                      style="float: right"
                    >
                      فایل با موفقیت بارگذاری شد.
                    </div></b-col
                  >
                  <b-row style="float: left" class="mr-1">
                    <b-col>
                      <span
                        class="mt-3"
                        v-if="reports2[selectedItem.index].file"
                        ><a
                          class="btn btn-success mt-3"
                          :href="reports2[selectedItem.index].file"
                          target="blank"
                          >دریافت</a
                        ></span
                      >
                      <b-button
                        style="height: 34px"
                        v-if="reports2[selectedItem.index].file"
                        class="btn ml-2 mt-3"
                        variant="danger"
                        @click="removeReportFile()"
                        >حذف</b-button
                      >
                    </b-col>
                  </b-row>
                </b-row>
              </b-col>
            </b-form-group>
          </b-form-group>

          <b-form-group label="بارگذاری درخواست مالی">
            <b-form-group>
              <b-form-file
                :state="Boolean(reports2[selectedItem.index].financeFile)"
                @input="myReportUpload(reportFinanceFile, 1, 'financeFile')"
                v-model="reportFinanceFile"
                browse-text="بارگذاری"
                :placeholder="
                  reports2[selectedItem.index].financeFile
                    ? reports2[selectedItem.index].financeFile
                    : 'فایل مربوطه را بارگذاری کنید (حداکثر ۵ مگابایت)'
                "
              ></b-form-file>
            </b-form-group>

            <b-form-group>
              <b-col>
                <b-progress
                  v-if="Boolean(myReportFile[1].uploadPercentage)"
                  :value="myReportFile[1].uploadPercentage"
                  :max="max"
                  show-progress
                  :animated="myReportFile[1].striped"
                  :variant="myReportFile[1].variant"
                ></b-progress>
                <b-row>
                  <b-col cols="6">
                    <div
                      v-if="myReportFile[1].isUploaded"
                      color="green"
                      class="mt-3"
                      style="float: right"
                    >
                      فایل با موفقیت بارگذاری شد.
                    </div></b-col
                  >
                  <b-row style="float: left" class="mr-1">
                    <b-col>
                      <span
                        class="mt-3"
                        v-if="reports2[selectedItem.index].financeFile"
                        ><a
                          class="btn btn-success mt-3"
                          :href="reports2[selectedItem.index].financeFile"
                          target="blank"
                          >دریافت</a
                        ></span
                      >
                      <b-button
                        style="height: 35px"
                        v-if="reports2[selectedItem.index].financeFile"
                        class="btn ml-2 mt-3"
                        variant="danger"
                        @click="removeRequestFile()"
                        >حذف</b-button
                      >
                    </b-col>
                  </b-row>
                </b-row>
              </b-col>
            </b-form-group>
          </b-form-group>

          <b-form-group label="درصد کل پیشرفت پروژه از ابتدا تا کنون از 100 :">
            <b-form-input
              type="number"
              :no-wheel="true"
              min="0"
              max="100"
              class="myselect2"
              @change="dynamicOver100('reports', selectedItem.index, 'percent')"
              v-model="reports2[selectedItem.index].percent"
            >
            </b-form-input>
          </b-form-group>
          <b-form-group label="توضیحات:">
            <b-form-textarea
              class="myselect2"
              v-model="reports2[selectedItem.index].description"
            >
            </b-form-textarea>
          </b-form-group>
          <b-row
            v-if="projectControl.contract && !projectControl.contractFileId"
          >
            <i
              class="fa fa-exclamation-triangle fa-2x text-warning ml-3"
              aria-hidden="true"
            ></i>
            <p class="required mt-1">
              به منظور ثبت گزارش می‌بایست ابتدا فایل قرارداد را بارگذاری نمایید
            </p>
          </b-row>
        </b-card>
      </div>
      <template v-slot:modal-footer>
        <b-button
          block
          :disabled="
            newReportBusy ||
            (projectControl.contract && !projectControl.contractFileId)
          "
          variant="success"
          size="lg"
          @click="researcherSubmitReport(reports[selectedItem.index].id)"
          >ثبت</b-button
        >
      </template>
    </b-modal>
    <b-modal
      id="researcherViewReport"
      ref="researcherViewReport"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center border-0"
      size="md"
      centered
    >
      <template v-slot:modal-header class="border-0">
        <h4>جزییات گزارش</h4>
      </template>
      <div v-if="role == 'researcher'">
        <b-card header-bg-variant="default" class="border-0">
          <h4 class="text-center text-dark">گزارش پژوهشگر</h4>
          <b-form-group label="درصد کل پیشرفت پروژه از ابتدا تا کنون از 100 :">
            <b-form-input
              type="number"
              :no-wheel="true"
              min="0"
              max="100"
              class="myselect2"
              @change="dynamicOver100('reports', selectedItem.index, 'percent')"
              v-model="reports[selectedItem.index].percent"
              disabled
            >
            </b-form-input>
          </b-form-group>
          <b-form-group label="توضیحات:">
            <b-form-textarea
              class="myselect2"
              v-model="reports[selectedItem.index].description"
              disabled
            >
            </b-form-textarea>
          </b-form-group>
          <hr />
          <h4 class="text-center text-dark">گزارش مدیر</h4>
          <b-form-group label="درصد کل پیشرفت پروژه از ابتدا تا کنون از 100 :">
            <b-form-input
              type="number"
              :no-wheel="true"
              min="0"
              max="100"
              class="myselect2"
              @change="
                dynamicOver100('reports', selectedItem.index, 'adminPer')
              "
              v-model="reports[selectedItem.index].adminPer"
              disabled
            >
            </b-form-input>
          </b-form-group>
          <b-form-group label="توضیحات:">
            <b-form-textarea
              class="myselect2"
              v-model="reports[selectedItem.index].adminMessage"
              disabled
            >
            </b-form-textarea>
          </b-form-group>
        </b-card>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="warning" block @click="hideViewModal()"
          >بستن</b-button
        >
      </template>
    </b-modal>
    <!--<b-modal
      id="adminViewFile"
      ref="adminViewFile"
      header-bg-variant="primary"
      header-text-variant="white"
      class="text-center border-0"
      size="xl"
      centered
      hide-footer
    >
      <template v-slot:modal-header class="border-0">
        <h4>جزییات گزارش</h4>
      </template>
      <div v-if="role == 'admin'">
        <h5 class="text-primary">فایل‌های پژوهشگر</h5>
        <b-table
          responsive
          small
          show-empty
          head-variant="light"
          :items="
            adminViewFileItems.filter(
              (x) => x.id == adminViewFileItems[reportSelectedItem]
            )
          "
          :fields="adminViewFileFields"
          empty-text="رکوردی برای نمایش وجود ندارد"
          class="table table-secondary"
        >
          <template v-slot:head()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.label }}
            </div>
          </template>
          <template v-slot:cell()="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(percent)="data">
            <div style="text-align: center; vertical-align: middle">
              <span v-if="data.value">%{{ data.value }}</span>
            </div>
          </template>
          <template v-slot:cell(index)="data">
            <div style="text-align: center; vertical-align: middle">
              {{ data.index + 1 }}
            </div>
          </template>
          <template v-slot:cell(uploadedFile)="data">
            <a
              v-if="data.item.uploadedFile.url"
              class="btn btn-success"
              :href="data.item.uploadedFile.url"
              target="_blank"
              >دریافت</a
            >
            <p v-if="!data.item.uploadedFile.url" class="text-danger">
              فایلی بارگذاری نشده است!
            </p>
          </template>
        </b-table>
        <br />
      </div>
    </b-modal>-->
    <b-modal
      hide-footer
      centered
      id="forceFinishedModal"
      title="اتمام کنترل پروژه"
    >
      <h5 style="line-height: 30px">
        گزارشی با درصد پیشرفت 100 وجود ندارد، آیا تمایل به اتمام کنترل پروژه
        دارید؟
      </h5>
      <div class="d-flex justify-content-end mt-3">
        <b-button class="w-50" variant="outline-primary" @click="forceFinish()"
          >بله</b-button
        >
        <b-button
          class="mx-2 w-50"
          variant="danger"
          @click="$bvModal.hide('forceFinishedModal')"
          >لغو</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment-jalaali"; // NOTE (IMPORT) to convert dates to each other
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection tool for persian date & time
const sarmadGantt = () => import("./sarmadGantt");
import Select2 from "v-select2-component"; // NOTE (IMPORT) to add an option to universitys drop down list which allow to user to type and search

export default {
  name: "Opportunity",
  props: ["role"],
  components: {
    datePicker: VuePersianDatetimePicker,
    sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
    Select2, // NOTE (COMPONENT) component of select2 plugin
  },
  data() {
    return {
      editContract: false,
      editStatus: false,
      editReferee: false,
      editAccelerator: false,
      editMessage: false,
      reports: [],
      reports2: [],
      pageLoaded: false,
      resFileBusy: false,
      adminViewFileItems: [],
      adminViewFileFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "عنوان فایل" },
        { key: "date", label: "تاریخ فایل" },
        { key: "uploadedFile", label: "فایل" },
      ],
      researcherFileItems: [],
      researcherFileFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان فایل" },
        { key: "date", label: "تاریخ فایل" },
        { key: "upload", label: "بارگذاری" },
      ],
      adminFilesItems: [],
      adminFilesFields: [
        { key: "index", label: "ردیف" },
        { key: "title", label: "عنوان فایل" },
        { key: "date", label: "تاریخ فایل" },
        { key: "operation", label: "عملیات" },
      ],
      editClick: false,
      tableBusy: false,
      contractFileFields: [
        { key: "index", label: "ردیف" },
        { key: "showName", label: "نام فایل" },
        { key: "url", label: "دریافت" },
      ],
      refFileFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام فایل" },
        { key: "url", label: "دریافت" },
      ],
      refFiles: [],
      refereeReport: {},
      additionalFiles: {
        contract: { uploadPercentage: 0 },
        report: { uploadPercentage: 0 },
        request: { uploadPercentage: 0 },
      },
      adminReportsItems: [{}],
      adminReportsItems2: [{ status: "", adminpercent: "", adminMessage: "" }],
      tabIndex: 3,
      newReportBusy: false,
      reportSelectedItem: {
        item: [],
        index: 0,
      },
      selectedItem: {
        item: [],
        index: 0,
      },
      uploadedFilesProject: [],
      uploadedFiles: [],
      max: 100,
      fileFields: [
        { key: "index", label: "ردیف" },
        { key: "showName", label: "نام فایل" },
        { key: "title", label: "عنوان فایل" },
        { key: "url", label: "دریافت" },
      ],
      reportFileFields: [
        { key: "index", label: "ردیف" },
        { key: "fileName", label: "نام فایل" },
        { key: "type", label: "عنوان فایل" },
        { key: "subject", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "url", label: "دریافت" },
      ],
      myFile: {
        isUploaded: false,
        uploadPercentage: 0,
      },
      myReportFile: [
        {
          isUploaded: false,
          uploadPercentage: 0,
        },
        {
          isUploaded: false,
          uploadPercentage: 0,
        },
      ],
      exportDate: moment(new Date()).format("jDD/jMM/jYYYY"),
      rev: "",
      options: [
        { value: "registered", text: "ثبت شده" },
        { value: "underSupervision", text: "در دست نظارت" },
        { value: "holdByAdmin", text: "در دست ادمین" },
        { value: "needsCorrection", text: "نیازمند اصلاح" },
        { value: "approved", text: "تایید شده" },
        { value: "declined", text: "لغو" },
        { value: "incompleteFinish", text: "اختتام ناقص", disabled: "true" },
      ],
      acceleratorOptions: [
        { value: "registered", text: "ثبت شده" },
        { value: "underSupervision", text: "در دست نظارت" },
        { value: "holdByAdmin", text: "در دست ادمین" },
        {
          value: "holdByAccelerator",
          text: "در انتظار بررسی شتاب دهنده",
        },
        { value: "needsCorrection", text: "نیازمند اصلاح" },
        { value: "approved", text: "تایید شده" },
        { value: "declined", text: "لغو" },
        { value: "incompleteFinish", text: "اختتام ناقص", disabled: "true" },
      ],
      secOptions: [
        { value: "registered", text: "ثبت شده" },
        { value: "declined", text: "لغو" },
      ],
      reportStatus: "",
      statusOpt: [
        {
          text: "پذیرش علمی-در انتظار ادمین",
          value: "پذیرش علمی-در انتظار ادمین",
          eng: "scientificApproved",
        },
        { text: "درحال انجام", value: "درحال انجام", eng: "ongoing" },
        { text: "اتمام", value: "اتمام", eng: "finished" },
        { text: "اختتام ناقص", value: "اختتام ناقص", eng: "incompleteFinish" },
      ],
      refereeItems: [],
      refereeFields: [
        { key: "index", label: "ردیف" },
        { key: "refereeId", label: "ناظر" },
        { key: "judge", label: "وضعیت" },
        { key: "judgePer", label: "درصد پیشرفت" },
        { key: "judgeDescription", label: "توضیحات" },
      ],
      researcherItems: [],
      researcherFields: [
        { key: "index", label: "ردیف" },
        { key: "subject", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "percent", label: "درصد پیشرفت" },
        { key: "description", label: "توضیحات" },
        { key: "url", label: "فایل" },
      ],
      adminFields: [
        { key: "index", label: "ردیف" },
        { key: "subject", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "adminPer", label: "درصد پیشرفت" },
        { key: "adminMessage", label: "توضیحات" },
      ],
      acceleratorFields: [
        { key: "index", label: "ردیف" },
        { key: "acceleratorStatus", label: "وضعیت" },
        { key: "accelerator", label: "شتاب‌دهنده" },
        { key: "reportAcceleratorDecision", label: "تصمیم" },
        { key: "reportAcceleratorPerc", label: "درصد پیشرفت" },
        { key: "acceleratorDescription", label: "توضیحات" },
      ],
      reviewersFields: [],
      reviewersData: "",
      reportsItems: [{ files: [] }],
      reportsFields: [
        { key: "index", label: "ردیف" },
        { key: "subject", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "status", label: "وضعیت" },
        { key: "operation", label: "عملیات" },
      ],
      reportItems: [],
      reportFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "عنوان گزارش" },
        { key: "date", label: "تاریخ گزارش" },
        { key: "operation", label: "" },
      ],
      projectControl: [],
      editProjectControl: [],
      oldData: [],
      expireDisable: false,
      statusDictionary: [
        { en: "Done", fa: "تمام" },
        { en: "NotDone", fa: "ناتمام" },
        { en: "Expired", fa: "منقضی" },
      ],
      rejectCause: "",
      rejectOptions: [],
      infoo: "",
      isLoaded: true,
      promises: {},
      eduGradeOptions: [
        "--مقطع را انتخاب کنید",
        "کارشناسی",
        "کارشناسی ارشد",
        "دکتری",
        "دکتری حرفه ای",
      ],
      fileBusy: true,
      selectedStatus: null,
      selectedSituation: "",
      comments: "",
      judgements: [],
      selectedJudgement: {},
      journalsFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام" },
        { key: "message", label: "پیام" },
        { key: "date", label: "تاریخ" },
      ],
      judgementFields: [
        { key: "index", label: "#" },
        { key: "status", label: "وضعیت" },
        { key: "referee", label: "داور" },
        { key: "decision", label: "تصمیم" },
        { key: "judgeDate", label: "تاریخ داوری" },
        { key: "description", label: "توضیحات" },
      ],
      situationsOptions: [
        { id: 2, eng: "registered", text: "ثبت شده" },
        { id: 3, eng: "underSupervision", text: "درحال بررسی" },
        { id: 4, eng: "inReview", text: "در دست داوری" },
        { id: 5, eng: "reviewDone", text: "جمع بندی نظرات داوران" },
        { id: 10, eng: "initialAccept", text: "پذیرش اولیه" },
        // { id: 5, text: "تایید اولیه" },
        { id: 11, eng: "corrected", text: "اصلاح شده" },
        { id: 6, eng: "finalAccept", text: "تایید نهایی" },
        { id: 7, eng: "incomplete", text: "نیاز به تکمیل / اصلاح" },
        { id: 8, eng: "rejected", text: "رد شده است" },
        { id: 9, eng: "declined", text: "لغو" },
      ],

      moment: moment,
      ckeckbox: {},
      show: false,
      busy: false,
      initial: {},
      doi: "",
      code: {},
      source: "",
      specs: {},
      serviceItems: [],
      executor: {},
      proposal: {},
      universities: [],
      otherUniversity: "",
      mehvars: [],
      otherMehvars: "",
      zone: new Array(6).fill(false),
      achievmentitems: [],
      timeitems: [],
      timeFields: [
        { key: "index", label: "ردیف" },
        { key: "dispatchDate", label: "تاریخ اعزام" },
        { key: "duration", label: "مدت زمان دوره" },
        { key: "returnDate", label: "تاریخ برگشت" },
        {
          key: "proposalSubject",
          label: "طرح هایی که در آن شرکت داشته اید",
        },
        { key: "operation", label: "" },
      ],
      timeFieldsDoc: [
        { key: "index", label: "ردیف" },
        { key: "dispatchDate", label: "تاریخ اعزام" },
        { key: "duration", label: "مدت زمان دوره" },
        { key: "returnDate", label: "تاریخ برگشت" },
        {
          key: "proposalSubject",
          label: "طرح هایی که در آن شرکت داشته اید",
        },
      ],
      achievitems: [],
      achievFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد" },
        { key: "operation", label: "" },
      ],
      achievFieldsDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد" },
      ],
      articlesItems: [],
      articlesFields: [
        { key: "index", label: "#" },
        { key: "subject", label: "عنوان" },
        { key: "releaseYear", label: "سال انتشار" },
        { key: "refrence", label: "تعداد ارجاع" },
        { key: "writersName", label: "نام نویسندگان" },
        { key: "magName", label: "نام مجله" },
        { key: "upload", label: "آپلود فایل" },
        { key: "operation", label: "" },
      ],
      articlesFieldsDoc: [
        { key: "index", label: "#" },
        { key: "subject", label: "عنوان" },
        { key: "releaseYear", label: "سال انتشار" },
        { key: "refrence", label: "تعداد ارجاع" },
        { key: "writersName", label: "نام نویسندگان" },
        { key: "magName", label: "نام مجله" },
      ],
      proposalStudies: false,
      proposalDevelopment: false,
      proposalPractical: false,
      drPosition: ["مربی", "استادیار", "دانشیار", "استاد‌تمام"],
      committieType: ["وزارت علوم", "وزارت بهداشت"],
      lastDegree: ["کارشناسی", "کارشناسی ارشد", "دکتری"],
      support: "",
      supportSetad: "",
      selectedMehvar: 0,
      fileFilter: "",
      taahol: "",
      DoiItem: [],
      DoiField: [
        { key: "subject", label: "عنوان" },
        { key: "mag", label: "مجله" },
        { key: "if", label: "IF" },
        { key: "year", label: "سال" },
      ],
      inventionItem: [],
      inventionField: [
        { key: "subject", label: "عنوان" },
        { key: "year", label: "سال" },
        { key: "description", label: "توضیحات" },
      ],
      file: null,
      OrgCostItem: [],
      OrgCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود).",
        },
        { key: "totalPrice", label: "هزینه (ریال)" },
        { key: "operation", label: "" },
      ],
      OrgCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام موسسه" },
        {
          key: "description",
          label: "نوع همكاری (شرح وظایف به طور دقیق و شفاف مشخص شود).",
        },
        { key: "totalPrice", label: "هزینه (ریال)" },
      ],
      deviceCostField: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        { key: "consumable", label: "مصرفی" },
        { key: "fund", label: "سرمایه‌ای" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد" },
        { key: "perPrice", label: "قیمت واحد به ریال" },
        { key: "totalPrice", label: "قیمت کل به ریال" },
        { key: "operation", label: "" },
      ],
      deviceCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستگاه" },
        { key: "consumable", label: "مصرفی" },
        { key: "fund", label: "سرمایه‌ای" },
        { key: "source", label: "محل تامین", cssClass: "table-column" },
        { key: "number", label: "تعداد" },
        { key: "perPrice", label: "قیمت واحد به ریال" },
        { key: "totalPrice", label: "قیمت کل به ریال" },
      ],
      achievmentFields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
        { key: "operation", label: "" },
      ],
      achievmentFieldsDoc: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دستاورد و خروجی" },
      ],
      serviceFields: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
        { key: "cellColor", label: "رنگ" },
        { key: "operation", label: "" },
      ],
      serviceFieldsDoc: [
        { key: "index", label: "#" },
        { key: "description", label: "شرح فعالیت‌ها" },
        { key: "percent", label: "درصد وزنی فعالیت " },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "dueDate", label: "تاریخ پایان" },
      ],
      tripCostField: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه (ریال)" },
        { key: "operation", label: "" },
      ],
      tripCostFieldDoc: [
        { key: "index", label: "#" },
        { key: "destination", label: "مقصد" },
        { key: "reason", label: "منظور از مسافرت" },
        { key: "number", label: "تعداد افراد" },
        { key: "day", label: "نفر روز" },
        { key: "cost", label: "هزینه (ریال)" },
      ],
      addFile: {
        fileName: "",
        fileDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      },
      acc: 0,
      otherFiles: new Array(10).fill({
        isUploaded: false,
      }),
      myshow: false,
      newReportSubject: "",
      newReportDate: "",
      supervisors: [
        {
          id: "",
          name: "",
          lastName: "",
          mobile: "",
          natCode: "",
          email: "",
          position: "",
          lastDegree: "",
          UniversityId: "",
          UniversityOther: "",
          UniversityJobId: "",
          UniversityJobOther: "",
          resumeFileId: "",
          resumeFile: "",
        },
      ],
      newSupervisor: {},
      advisors: [
        {
          id: "",
          name: "",
          lastName: "",
          mobile: "",
          email: "",
          position: "",
          lastDegree: "",
          UniversityOther: "",
          UniversityJobOther: "",
        },
      ],
      pcUploadedFiles: [],
      contractName: "",
      resReportFiles: [],
      reportFiles: [],
      contractUrl: "",
      uploadedContract: false,
      reportFile: [],
      reportFinanceFile: [],
      myPcFile: [],
      resContractFile: [],
      accelerators: [],
      newAcceleratorId: "",
      reactivity: false,
    };
  },
  computed: {
    computedLength() {
      let checker = 0;
      let all = this.reportItems.length * 2;
      if (this.reportItems.length) {
        this.reportItems.forEach((x) => {
          x.name != "" ? checker++ : 1;
          x.date != "" ? checker++ : 1;
        });
        return !(checker == all);
      }
    },
    computedReportFiles() {
      let myFiles = [];
      if (this.reports.length) {
        this.reports.forEach((report) => {
          if (report.file) {
            myFiles.push({
              fileName: report.fileName,
              subject: report.subject,
              url: report.file,
              date: report.date,
              type: "گزارش",
            });
          }
          if (report.financeFile) {
            myFiles.push({
              fileName: report.financeFileName,
              subject: report.subject,
              url: report.financeFile,
              date: report.date,
              type: "درخواست مالی",
            });
          }
        });
      }
      return myFiles;
    },
    computedDisable() {
      let disable = false;
      if (!this.refereeReport.reportJudge) {
        disable = true;
      } else {
        if (this.refereeReport.reportJudge == "approve") {
          if (
            !this.refereeReport.judgePercent ||
            !this.refereeReport.judgeDescription
          ) {
            disable = true;
          }
        } else if (this.refereeReport.reportJudge == "reject") {
          if (
            !this.refereeReport.refereeRejectionCause ||
            !this.refereeReport.judgePercent
          ) {
            disable = true;
          }
        } else {
          disable = true;
        }
      }
      return disable;
    },
    computedReviewer() {
      let rev = "";
      if (this.reviewersData == "") {
        rev = "--";
      }
      if (this.reviewersData) {
        try {
          rev = this.reviewersFields.filter(
            (x) => x.id == this.reviewersData
          )[0].text;
        } catch (error) {
          rev = "--";
        }
      } else if (this.projectControl.refereeId) {
        try {
          rev = this.reviewersFields.filter(
            (x) => x.id == this.projectControl.refereeId
          )[0].text;
        } catch (error) {
          rev = "--";
        }
      }
      return rev;
    },
    //computedItems() {
    // if (this.role == "admin") {
    //    if (this.adminReportsItems) {
    //      return this.adminReportsItems.sort((a, b) => {
    //        if (a.time < b.time) {
    //          return 1;
    //        }
    //        if (a.time > b.time) {
    //          return -1;
    //        }
    //        // a must be equal to b
    //        return 0;
    //      });
    //    } else return [];
    //  } else if (this.role == "researcher") {
    //    if (this.reportsItems) {
    //      return this.reportsItems.sort((a, b) => {
    //        if (a.time < b.time) {
    //          return 1;
    //        }
    //        if (a.time > b.time) {
    //          return -1;
    //        }
    //        // a must be equal to b
    //        return 0;
    //      });
    //    } else return [];
    //  }
    //},
    //computedJournals() {
    //  if (this.projectControl.journals) {
    //    return this.projectControl.journals.sort((a, b) => {
    //      if (a.timeStamp < b.timeStamp) {
    //        return 1;
    //      }
    //      if (a.timeStamp > b.timeStamp) {
    //        return -1;
    //      }
    //      // a must be equal to b
    //      return 0;
    //    });
    //  } else return [];
    //},
    computedRefereeJournals() {
      if (this.refereeReport.journals) {
        return this.refereeReport.journals.sort((a, b) => {
          if (a.timeStamp < b.timeStamp) {
            return 1;
          }
          if (a.timeStamp > b.timeStamp) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      } else return [];
    },
    computedTotalCost() {
      let tempPrice =
        (this.PersonnelCostItem.length == 0
          ? 0
          : this.PersonnelCostItem.map(
              (x) => parseInt(x.perPersonCost) * parseInt(x.cooperationHour)
            ).reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.tripCostItem.length == 0
          ? 0
          : this.tripCostItem
              .map((x) => x.cost)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.deviceCostItem.length == 0
          ? 0
          : this.deviceCostItem
              .map((x) => parseInt(x.perPrice) * parseInt(x.number))
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) +
        (this.otherCostItem.length == 0
          ? 0
          : this.otherCostItem
              .map((x) => x.totalPrice)
              .reduce((a, b) => parseInt(a) + parseInt(b), 0)) -
        (this.OrgCostItem.length == 0
          ? 0
          : this.OrgCostItem.map((x) => x.totalPrice).reduce(
              (a, b) => parseInt(a) + parseInt(b),
              0
            ));

      if (tempPrice > 0) return tempPrice;
      else return 0;
    },
  },
  methods: {
    finalUpload() {
      this.resFileBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/researcher/pc/opportune/addPcFiles",
          {
            pcId: this.$route.params.id,
            pcFiles: this.researcherFileItems,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.resFileBusy = false;
          setTimeout(() => {
            this.showProject();
          }, 300);
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.resFileBusy = false;
        });
    },
    researcherUpload(file, index) {
      //CHECK FILE SIZE
      if (!file) {
        return;
      }
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        this.myPcFile[index].showProgress = true;
        this.myPcFile[index].variant = "info";
        this.myPcFile[index].uploadPercentage = 0;
        this.myPcFile[index].isUploaded = false;
        this.myPcFile[index].uploadButDisable = true;

        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl +
              "/setad/researcher/pc/opportune/upload?pcId=" +
              this.$route.params.id,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.myPcFile[index].uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((res) => {
            if (res.status == 200) {
              this.myPcFile[index].isUploaded = true;
              this.myPcFile[index].uploadPercentage = 100;
              this.myPcFile[index].striped = false;
              this.myPcFile[index].variant = "success";
              this.myPcFile[index].uploadButDisable = false;
              this.researcherFileItems[index].file = res.data.url;
              this.researcherFileItems[index].fileId = res.data.id;
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.myPcFile[index].uploadPercentage = 0;
            this.myPcFile[index].isUploaded = false;
            this.myPcFile[index].showProgress = false;
          });
      }
    },
    removeReportFile() {
      this.reportFile = [];
      this.reports2[this.selectedItem.index].file = "";
      this.reports2[this.selectedItem.index].fileId = "";
      this.myReportFile[0].uploadPercentage = 0;
      this.myReportFile[0].isUploaded = false;
      this.myReportFile[0].showProgress = false;
    },
    removeRequestFile() {
      this.reportFinanceFile = [];
      this.reports2[this.selectedItem.index].financeFile = "";
      this.reports2[this.selectedItem.index].financeFileId = "";
      this.myReportFile[1].uploadPercentage = 0;
      this.myReportFile[1].isUploaded = false;
      this.myReportFile[1].showProgress = false;
    },
    delContract(order) {
      this.uploadedFiles.splice(order, 1);
      this.additionalFiles.contract = {};
      this.myFile.uploadPercentage = 0;
      const title = (
        <div>
          <h5>حذف قرارداد</h5>
          <span>قرارداد مورد نظر شما حذف شد</span>
        </div>
      );
      this.toast(title, "error");
    },
    addJudgeReport() {
      this.newReportBusy = true;
      this.$http
        .post(
          this.baseUrl + "/setad/reviewer/report/opportune/done",
          {
            reportId: this.$route.params.id,
            reportJudgePer: this.refereeReport.judgePercent,
            reportJudge: this.refereeReport.reportJudge,
            judgeDescription:
              this.refereeReport.reportJudge == "approve"
                ? this.refereeReport.judgeDescription
                : this.refereeReport.refereeRejectionCause,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 202) {
            this.toast(res.data.text, "success");
            this.toast(res.data.error, "error");
          } else {
            this.toast(res.data, "success");
          }

          this.newReportBusy = false;
          this.$refs["researcherReport"].hide();
        })
        .then(() => {
          this.$router.push("/referee/doneProjectsControl");
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.newReportBusy = false;
          this.$bvModal.hide("loading");
          this.isLoaded = true;
        });
    },
    researcherSubmitReport(id) {
      this.newReportBusy = true;
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.$http
        .post(
          this.baseUrl + "/setad/researcher/pc/opportune/sendReport",
          {
            reportId: id,
            fileId: this.reports2[this.selectedItem.index].fileId,
            financeFileId: this.reports2[this.selectedItem.index].financeFileId,
            reportPerc: this.reports2[this.selectedItem.index].percent,
            description: this.reports2[this.selectedItem.index].description,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.newReportBusy = false;
          this.$refs["researcherReport"].hide();
          setTimeout(() => {
            this.showProject();
            this.$bvModal.hide("loading");
            this.isLoaded = true;
          }, 300);
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.newReportBusy = false;
          this.$bvModal.hide("loading");
          this.isLoaded = true;
        });
    },
    myReportUpload(file, index, name) {
      if (!file) {
        return;
      }

      //CHECK FILE SIZE
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;
      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");

        return;
      } else {
        // START UPLOAD PROCESS

        this.myReportFile[index].showProgress = true;
        this.myReportFile[index].variant = "info";
        this.myReportFile[index].uploadPercentage = 0;
        this.myReportFile[index].isUploaded = false;
        this.myReportFile[index].uploadButDisable = true;

        var formData = new FormData();

        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl +
              "/setad/researcher/pc/opportune/upload?pcId=" +
              this.$route.params.id,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.myReportFile[index].uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((res) => {
            if (res.status == 200) {
              this.myReportFile[index].isUploaded = true;

              this.myReportFile[index].uploadPercentage = 100;

              this.myReportFile[index].striped = false;

              this.myReportFile[index].variant = "success";

              this.myReportFile[index].uploadButDisable = false;

              this.reports2[this.selectedItem.index][name] = res.data.url;

              this.reports2[this.selectedItem.index][name + "Id"] = res.data.id;
            }
          })
          .catch((err) => {
            alert("err");
            console.log(err);
            this.toast(err.response.data, "error");
            this.myReportFile[index].uploadPercentage = 0;
          });
      }
    },
    researcherContractUpload(file) {
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        // START UPLOAD PROCESS
        this.myFile.showProgress = true;
        this.myFile.variant = "info";
        this.myFile.uploadPercentage = 0;
        this.myFile.isUploaded = false;
        this.myFile.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl +
              "/setad/researcher/pc/opportune/uploadContract?pcId=" +
              this.$route.params.id,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.myFile.uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((res) => {
            if (res.status == 200) {
              this.myFile.isUploaded = true;
              this.myFile.uploadPercentage = 100;
              this.myFile.striped = false;
              this.myFile.variant = "success";
              this.myFile.uploadButDisable = false;
              this.projectControl.contractFile = res.data.url;
              this.contractName = res.data.name;
              this.uploadedContract = true;
              this.showProject();
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.myFile.uploadPercentage = 0;
          });
      }
    },
    contractStatus() {
      this.$bvModal.show("loading");
      this.$http
        .post(
          this.baseUrl + "/setad/admin/pc/opportune/contract",
          {
            pcId: this.$route.params.id,
            contract: this.editProjectControl.contract,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          this.reactivity != this.reactivity;
          setTimeout(() => {
            this.showProject();
            this.editContract = false;
            this.$bvModal.hide("loading");
          }, 300);
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.$bvModal.hide("loading");
        });
    },
    editProjectStatus() {
      this.$bvModal.show("loading");

      let status = this.statusOpt.filter(
        (x) => x.text == this.editProjectControl.status
      )[0].eng;

      if (status == "incompleteFinish") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/pc/opportune/incompleteFinish",
            {
              pcId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            setTimeout(() => {
              this.showProject();
            }, 300);
            setTimeout(() => {
              this.editStatus = false;
              this.$bvModal.hide("loading");
            }, 400);

            this.toast(res.data, "success");
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.$bvModal.hide("loading");
          });
      } else if (status == "ongoing") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/pc/opportune/ongoing",
            {
              pcId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            setTimeout(() => {
              this.showProject();
            }, 300);
            setTimeout(() => {
              this.editStatus = false;
              this.$bvModal.hide("loading");
            }, 400);

            this.toast(res.data, "success");
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.$bvModal.hide("loading");
          });
      } else if (status == "scientificApproved") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/pc/opportune/scientificApproved",
            {
              pcId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            setTimeout(() => {
              this.showProject();
            }, 300);
            setTimeout(() => {
              this.editStatus = false;
              this.$bvModal.hide("loading");
            }, 400);

            this.toast(res.data, "success");
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.$bvModal.hide("loading");
          });
      } else if (status == "finished") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/pc/opportune/finished",
            {
              pcId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            setTimeout(() => {
              this.showProject();
            }, 300);
            setTimeout(() => {
              this.editStatus = false;
              this.$bvModal.hide("loading");
            }, 400);

            this.toast(res.data, "success");
          })
          .catch((err) => {
            if (err.response.status == 409) {
              this.$bvModal.show("forceFinishedModal");
              this.$bvModal.hide("loading");
            } else {
              console.log(err);
              this.toast(err.response.data, "error");
              this.$bvModal.hide("loading");
            }
          });
      }
    },
    submitNewReports() {
      this.$bvModal.hide("loading");
      this.$http
        .post(
          this.baseUrl + "/setad/admin/pc/opportune/addReport",
          {
            pcId: this.$route.params.id,
            subject: this.newReportSubject,
            date: this.newReportDate,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          setTimeout(() => {
            this.showProject();
            this.newReportSubject = "";
            this.newReportDate = "";
          }, 300);
          this.$bvModal.hide("loading");
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.$bvModal.hide("loading");
        });
    },
    editFiles() {
      this.$bvModal.hide("loading");
      this.$http
        .post(
          this.baseUrl + "/setad/admin/pc/opportune/pcFiles",
          {
            pcId: this.$route.params.id,
            pcFiles: this.adminFilesItems,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");

          setTimeout(() => {
            this.showProject();
          }, 300);
          this.$bvModal.hide("loading");
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.$bvModal.hide("loading");
        });
    },
    //adminEditPc() {
    //  this.newReportBusy = true;
    //  let projectControlContract =
    //    this.projectControl.contract == "Yes" ? true : false;
    //  this.$http
    //    .post(
    //      this.baseUrl + "/setad/admin/editPcId",
    //      {
    //        cpId: this.$route.params.id,
    //        contract: projectControlContract,
    //        situation: this.statusOpt.filter(x => x.value == this.projectControl.status)[0].eng,
    //        refereeId: this.reviewersData,
    //        reports: JSON.stringify(this.reportItems),
    //        filesCP: JSON.stringify(this.adminFilesItems),
    //        adminMessage: this.projectControl.adminMessage
    //      },
    //      {
    //        headers: {
    //          Authorization: "Bearer: " + localStorage.getItem("userId")
    //        }
    //      }
    //    )
    //    .then(res => {
    //      this.toast(res.data, "success");
    //      this.newReportBusy = false;
    //      if (this.projectControl.status == "اتمام") {
    //        this.$router.push("/admin/archivePc");
    //      }
    //      if (this.projectControl.status == "اختتام ناقص") {
    //        this.$router.push("/admin/archivePc");
    //      }
    //      setTimeout(() => {
    //        this.showProject();
    //      }, 300);
    //      this.newReportBusy = false;
    //      this.reportItems = [];
    //    })
    //    .catch(err => {
    //      console.log(err)
    //      this.newReportBusy = false;
    //    });
    //},
    adminEditReport(id) {
      this.newReportBusy = true;
      this.$bvModal.show("loading");
      let status = this.reportStatus;

      if (status == "declined") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/report/declined",
            {
              reportId: id,
              adminPer:
                this.adminReportsItems2[this.reportSelectedItem.index].adminPer,
              adminMessage:
                this.adminReportsItems2[this.reportSelectedItem.index]
                  .adminMessage,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.newReportBusy = false;
            this.$refs["report"].hide();
            setTimeout(() => {
              this.showProject();
            }, 400);
            this.$bvModal.hide("loading");
            this.toast(res.data, "success");
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.newReportBusy = false;
            this.$bvModal.hide("loading");
          });
      } else if (status == "underSupervision") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/report/underSupervision",
            {
              reportId: id,
              adminPer:
                this.adminReportsItems2[this.reportSelectedItem.index].adminPer,
              adminMessage:
                this.adminReportsItems2[this.reportSelectedItem.index]
                  .adminMessage,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.newReportBusy = false;
            this.$refs["report"].hide();
            setTimeout(() => {
              this.showProject();
            }, 400);
            this.$bvModal.hide("loading");

            this.toast(res.data, "success");
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.newReportBusy = false;
            this.$bvModal.hide("loading");
          });
      } else if (status == "approved") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/report/approved",
            {
              reportId: id,
              adminPer:
                this.adminReportsItems2[this.reportSelectedItem.index].adminPer,
              adminMessage:
                this.adminReportsItems2[this.reportSelectedItem.index]
                  .adminMessage,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.newReportBusy = false;
            this.$refs["report"].hide();
            setTimeout(() => {
              this.showProject();
            }, 400);
            this.$bvModal.hide("loading");

            this.toast(res.data, "success");
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.newReportBusy = false;
            this.$bvModal.hide("loading");
          });
      } else if (status == "holdByAdmin") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/report/holdByAdmin",
            {
              reportId: id,
              adminPer:
                this.adminReportsItems2[this.reportSelectedItem.index].adminPer,
              adminMessage:
                this.adminReportsItems2[this.reportSelectedItem.index]
                  .adminMessage,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.newReportBusy = false;
            this.$refs["report"].hide();
            setTimeout(() => {
              this.showProject();
            }, 400);
            this.$bvModal.hide("loading");

            this.toast(res.data, "success");
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.newReportBusy = false;
            this.$bvModal.hide("loading");
          });
      } else if (status == "holdByAccelerator") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/report/holdByAccelerator",
            {
              reportId: id,
              adminPer:
                this.adminReportsItems2[this.reportSelectedItem.index].adminPer,
              adminMessage:
                this.adminReportsItems2[this.reportSelectedItem.index]
                  .adminMessage,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.newReportBusy = false;
            this.$refs["report"].hide();
            setTimeout(() => {
              this.showProject();
            }, 400);
            this.$bvModal.hide("loading");

            this.toast(res.data, "success");
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.newReportBusy = false;
            this.$bvModal.hide("loading");
          });
      } else if (status == "needsCorrection") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/report/needsCorrection",
            {
              reportId: id,
              adminPer:
                this.adminReportsItems2[this.reportSelectedItem.index].adminPer,
              adminMessage:
                this.adminReportsItems2[this.reportSelectedItem.index]
                  .adminMessage,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.newReportBusy = false;
            this.$refs["report"].hide();
            setTimeout(() => {
              this.showProject();
            }, 400);
            this.$bvModal.hide("loading");

            this.toast(res.data, "success");
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.newReportBusy = false;
            this.$bvModal.hide("loading");
          });
      } else if (status == "registered") {
        this.$http
          .post(
            this.baseUrl + "/setad/admin/report/registered",
            {
              reportId: id,
              adminPer:
                this.adminReportsItems2[this.reportSelectedItem.index].adminPer,
              adminMessage:
                this.adminReportsItems2[this.reportSelectedItem.index]
                  .adminMessage,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.newReportBusy = false;
            this.$refs["report"].hide();
            setTimeout(() => {
              this.showProject();
            }, 400);
            this.$bvModal.hide("loading");

            this.toast(res.data, "success");
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.newReportBusy = false;
            this.$bvModal.hide("loading");
          });
      }
    },

    forceFinish() {
      this.$bvModal.show("loading");
      this.$http
        .post(
          this.baseUrl + "/setad/admin/pc/opportune/forceFinished",
          {
            pcId: this.$route.params.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.$bvModal.hide("forceFinishedModal");
          setTimeout(() => {
            this.showProject();
          }, 300);
          setTimeout(() => {
            this.editStatus = false;
            this.$bvModal.hide("loading");
          }, 400);
          this.toast(res.data, "success");
        })

        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.$bvModal.hide("forceFinishedModal");
          this.$bvModal.hide("loading");
        });
    },
    editProjectReferee() {
      this.$bvModal.show("loading");

      this.$http
        .post(
          this.baseUrl + "/setad/admin/pc/opportune/manageReviewer",
          {
            pcId: this.$route.params.id,
            isReferee: this.editProjectControl.isReferee,
            refereeId: this.editProjectControl.isReferee
              ? this.reviewersData
              : "",
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          setTimeout(() => {
            this.showProject();
          }, 300);
          setTimeout(() => {
            this.editReferee = false;
            this.$bvModal.hide("loading");
          }, 400);
          this.toast(res.data, "success");
        })

        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.$bvModal.hide("loading");
        });
    },
    editProjectAccelerator() {
      this.$bvModal.show("loading");

      this.$http
        .post(
          this.baseUrl + "/setad/admin/pc/opportune/manageAccelerator",
          {
            pcId: this.$route.params.id,
            isAccelerator: this.editProjectControl.isAccelerator,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          setTimeout(() => {
            this.showProject();
          }, 300);
          setTimeout(() => {
            this.editAccelerator = false;
            this.$bvModal.hide("loading");
          }, 400);
          this.toast(res.data, "success");
        })

        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.$bvModal.hide("loading");
        });
    },
    editProjectMessage() {
      this.$bvModal.show("loading");
      this.$http
        .post(
          this.baseUrl + "/setad/admin/pc/opportune/messageToResearcher",
          {
            pcId: this.$route.params.id,
            adminMessage: this.editProjectControl.adminMessage,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.toast(res.data, "success");
          setTimeout(() => {
            this.showProject();
          }, 300);
          setTimeout(() => {
            this.editMessage = false;
            this.$bvModal.hide("loading");
          }, 400);
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
          this.$bvModal.hide("loading");
        });
    },
    myUpload(file) {
      if (!file) {
        return;
      }
      //CHECK FILE SIZE
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast("حجم فایل نباید از 5 مگابایت بیشتر باشد", "error");
        return;
      } else {
        // START UPLOAD PROCESS
        this.myFile.showProgress = true;
        this.myFile.variant = "info";
        this.myFile.uploadPercentage = 0;
        this.myFile.isUploaded = false;
        this.myFile.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);

        this.$http
          .post(
            this.baseUrl +
              "/setad/newUploads/private?id=" +
              this.$route.params.id,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.myFile.uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((res) => {
            if (res.status == 200) {
              this.myFile.isUploaded = true;
              this.myFile.uploadPercentage = 100;
              this.myFile.striped = false;
              this.myFile.variant = "success";
              this.myFile.uploadButDisable = false;
              this.uploadedFiles = res.data;
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.uploadedFiles = {};
            this.additionalFiles.contract = {};
            this.myFile.uploadPercentage = 0;
          });
      }
    },
    showModal(item, index) {
      this.reportSelectedItem = new Object({ item: item, index: index });
      this.reportStatus = !this.projectControl.isAccelerator
        ? this.options.filter(
            (x) =>
              x.text ==
              this.adminReportsItems[this.reportSelectedItem.index].status
          )[0].value
        : this.acceleratorOptions.filter(
            (x) =>
              x.text ==
              this.adminReportsItems[this.reportSelectedItem.index].status
          )[0].value;
      this.$refs["report"].show();
    },
    showAdminViewModal() {
      this.$refs["adminViewFile"].show();
    },
    showNewReport() {
      this.$refs["newReport"].show();
    },
    showResearcherModal(item, index) {
      this.selectedItem = new Object({ item: item, index: index });
      (this.myReportFile = [
        {
          isUploaded: false,
          uploadPercentage: 0,
        },
        {
          isUploaded: false,
          uploadPercentage: 0,
        },
      ]),
        (this.projectControl.percent = item.percent);
      this.projectControl.adminMessage = item.description;
      this.$refs["researcherReport"].show();
    },
    showResearcherView(item, index) {
      this.selectedItem = new Object({ item: item, index: index });
      this.$refs["researcherViewReport"].show();
    },
    hideViewModal() {
      this.$refs["researcherViewReport"].hide();
    },
    addReport() {
      // NOTE (m-addAchievment) to add achievements in the relevant sections
      this.reportItems.push({
        name: this.reportsItems.length
          ? "گزارش " +
            Number(this.reportItems.length + this.reportsItems.length + 1)
          : "گزارش " + Number(this.reportItems.length + 1),
        date: moment(new Date()).format("jYYYY/jMM/jDD"),
      });
    },
    adminDelFile(index) {
      this.adminFilesItems.splice(index, 1);
    },
    adminAddFile() {
      this.adminFilesItems.push({
        title: this.addFile.fileName,
        date: this.addFile.fileDate,
        fileId: null,
        file: [],
      });
      this.addFile = {
        fileName: "",
        fileDate: moment(new Date()).format("jYYYY/jMM/jDD"),
      };
    },
    dynamicOver100(role, index, variable) {
      if (
        this[role][index][variable] > 100 ||
        this[role][index][variable] < 0
      ) {
        this[role][index][variable] = "";
      }
    },
    over100() {
      if (
        this.refereeReport.judgePercent > 100 ||
        this.refereeReport.judgePercent < 0
      ) {
        this.refereeReport.judgePercent = "";
      }
    },
    removeReport(order) {
      // NOTE (m-delAchievment) to remove achievments in the relevant sections
      this.reportItems.splice(order, 1);
      const title = (
        <div>
          <h5>حذف گزارش</h5>
          <span>گزارش مورد نظر شما حذف شد</span>
        </div>
      );
      this.toast(title, "error");
    },
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} body{font-family:B Nazanin;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename = this.request.requestsCode + ".doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
    computedVariant(seed) {
      // REVIEW
      let variant = [
        "primary",
        "secondary",
        "success",
        "warning",
        "danger",
        "dark",
        "info",
        "light",
      ];
      return variant[seed % 8];
    },
    showProject() {
      if (this.role == "researcher") {
        this.$http
          .post(
            this.baseUrl + "/setad/researcher/pc/opportune/getInfo",
            {
              pcId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.request = res.data.request;
            this.projectControl = res.data.pc;
            this.reports = res.data.reports;
            this.reports2 = JSON.parse(JSON.stringify(this.reports));
            this.reviewersData = res.data.pc.refereeId;
            this.researcherFileItems = res.data.pc.pcFiles;
            !this.request.supervisors.length
              ? (this.supervisors = [
                  {
                    id: "",
                    name: "",
                    lastName: "",
                    mobile: "",
                    natCode: "",
                    email: "",
                    position: "",
                    lastDegree: "",
                    UniversityId: "",
                    UniversityOther: "",
                    UniversityJobId: "",
                    UniversityJobOther: "",
                    resumeFileId: "",
                    resumeFile: "",
                  },
                ])
              : (this.supervisors = res.data.request.supervisors);

            !this.request.advisors.length
              ? (this.advisors = [
                  {
                    id: "",
                    name: "",
                    lastName: "",
                    mobile: "",
                    email: "",
                    position: "",
                    lastDegree: "",
                    UniversityOther: "",
                    UniversityJobOther: "",
                  },
                ])
              : (this.advisors = res.data.request.advisors);
            this.myPcFile = JSON.parse(
              JSON.stringify(
                new Array(this.researcherFileItems.length).fill({
                  isUploaded: false,
                  uploadPercentage: 0,
                })
              )
            );
            setTimeout(() => {
              this.pageLoaded = true;
              this.show = true;
            }, 200);

            this.show = false;
            this.acc++;

            if (this.acc > 2) {
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
            this.fileBusy = false;
          })
          .catch((err) => {
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else if (this.role == "admin") {
        this.tableBusy = true;
        this.$http
          .post(
            this.baseUrl + "/setad/admin/pc/opportune/getInfo",
            {
              pcId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.request = res.data.request;
            this.projectControl = res.data.pc;
            this.adminReportsItems = res.data.reports;
            this.adminReportsItems2 = JSON.parse(
              JSON.stringify(this.adminReportsItems)
            );
            this.reviewersData = res.data.pc.refereeId;
            this.adminFilesItems = res.data.pc.pcFiles;

            !this.request.supervisors.length
              ? (this.supervisors = [
                  {
                    id: "",
                    name: "",
                    lastName: "",
                    mobile: "",
                    natCode: "",
                    email: "",
                    position: "",
                    lastDegree: "",
                    UniversityId: "",
                    UniversityOther: "",
                    UniversityJobId: "",
                    UniversityJobOther: "",
                    resumeFileId: "",
                    resumeFile: "",
                  },
                ])
              : (this.supervisors = res.data.request.supervisors);

            !this.request.advisors.length
              ? (this.advisors = [
                  {
                    id: "",
                    name: "",
                    lastName: "",
                    mobile: "",
                    email: "",
                    position: "",
                    lastDegree: "",
                    UniversityOther: "",
                    UniversityJobOther: "",
                  },
                ])
              : (this.advisors = res.data.request.advisors);

            setTimeout(() => {
              this.pageLoaded = true;
            }, 200);

            this.show = false;

            this.acc++;

            if (this.acc > 2) {
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms

              this.show = true;
            }, 200);

            // this.additionalFiles = JSON.parse(res.data.project.files);
            this.tableBusy = false;
            this.fileBusy = false;
          })
          .catch((err) => {
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            this.tableBusy = false;
            console.log({ err });
          });
      } else if (this.role == "referee") {
        this.$http
          .post(
            this.baseUrl + "/setad/reviewer/report/opportune/getInfo",
            {
              reportId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.request = res.data.request;
            this.refereeReport = res.data.report;

            this.refereeReport.judge = "";
            this.refereeReport.judgePercent = "";
            this.refereeReport.judgeDescription = "";
            !this.request.supervisors.length
              ? (this.supervisors = [
                  {
                    id: "",
                    name: "",
                    lastName: "",
                    mobile: "",
                    natCode: "",
                    email: "",
                    position: "",
                    lastDegree: "",
                    UniversityId: "",
                    UniversityOther: "",
                    UniversityJobId: "",
                    UniversityJobOther: "",
                    resumeFileId: "",
                    resumeFile: "",
                  },
                ])
              : (this.supervisors = res.data.request.supervisors);

            !this.request.advisors.length
              ? (this.advisors = [
                  {
                    id: "",
                    name: "",
                    lastName: "",
                    mobile: "",
                    email: "",
                    position: "",
                    lastDegree: "",
                    UniversityOther: "",
                    UniversityJobOther: "",
                  },
                ])
              : (this.advisors = res.data.request.advisors);

            this.reportFiles.push({
              name: "گزارش",
              url: this.refereeReport.file,
            }),
              this.refereeReport.financeFile
                ? this.reportFiles.push({
                    name: "درخواست مالی",
                    url: this.refereeReport.financeFile,
                  })
                : "",
              this.acc++;

            if (this.acc > 2) {
              this.$bvModal.hide("loading");
              this.isLoaded = true;
            }
            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms

              this.pageLoaded = true;
              this.show = true;
            }, 200);

            // this.additionalFiles = JSON.parse(res.data.project.files);

            this.fileBusy = false;
          })
          .catch((err) => {
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            console.log(err);
            this.toast(err.response.data, "error");
            this.$router.push("/referee/projectsControl");
          });
      }
    },
    onMounted() {
      // NOTE (MOUNTED) to show the data of this page
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.$root.$emit("show::modal", "loading");

      this.busyAll = true;
      if (this.role == "researcher") {
        let allUniMehvars = this.$http.post(
          this.baseUrl + "/setad/options/uniMehvars",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        );
        let allUniversities = this.$http.post(
          this.baseUrl + "/setad/options/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        );

        Promise.all([allUniMehvars, allUniversities]).then((res) => {
          let allMehv = res[0].data;
          let allUni = res[1].data;

          this.acc++;
          this.progressValue += 30;
          if (this.acc > 2) {
            this.$bvModal.hide("loading");
            this.isLoaded = true;

            this.busyAll = false;
          }
          this.mehvars = allMehv;
          this.mehvars.push(
            new Object({
              id: this.notMehvar,
              text: "سایر محورها",
              universityId: 1,
            })
          );

          this.acc++;
          this.progressValue += 30;
          if (this.acc > 2) {
            this.$bvModal.hide("loading");
            this.isLoaded = true;

            this.busyAll = false;
          }
          this.universities = allUni;
          this.universities.push(
            new Object({
              id: this.notUniversity,
              text: "سایر دانشگاه‌ها",
            })
          );
        });
      } else if (this.role == "referee") {
        let allUniMehvars = this.$http.post(
          this.baseUrl + "/setad/options/uniMehvars",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        );
        let allUniversities = this.$http.post(
          this.baseUrl + "/setad/options/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        );
        Promise.all([allUniMehvars, allUniversities]).then((res) => {
          let allMehv = res[0].data;
          let allUni = res[1].data;

          this.acc++;
          this.progressValue += 30;
          if (this.acc > 2) {
            this.$bvModal.hide("loading");
            this.isLoaded = true;

            this.busyAll = false;
          }
          this.mehvars = allMehv;
          this.mehvars.push(
            new Object({
              id: this.notMehvar,
              text: "سایر محورها",
              universityId: 1,
            })
          );

          this.acc++;
          this.progressValue += 30;
          if (this.acc > 2) {
            this.$bvModal.hide("loading");
            this.isLoaded = true;

            this.busyAll = false;
          }
          this.universities = allUni;
          this.universities.push(
            new Object({
              id: this.notUniversity,
              text: "سایر دانشگاه‌ها",
            })
          );
        });

        this.fileBusy = false;
      }

      this.fileBusy = false;
      if (this.role == "admin") {
        let allUniMehvars = this.$http.post(
          this.baseUrl + "/setad/options/uniMehvars",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        );
        let allUniversities = this.$http.post(
          this.baseUrl + "/setad/options/universities",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        );

        Promise.all([allUniMehvars, allUniversities]).then((res) => {
          let allMehv = res[0].data;
          let allUni = res[1].data;

          this.acc++;
          this.progressValue += 30;
          if (this.acc > 2) {
            this.$bvModal.hide("loading");
            this.isLoaded = true;

            this.busyAll = false;
          }
          this.mehvars = allMehv;
          this.mehvars.push(
            new Object({
              id: this.notMehvar,
              text: "سایر محورها",
              universityId: 1,
            })
          );

          this.acc++;
          this.progressValue += 30;
          if (this.acc > 2) {
            this.$bvModal.hide("loading");
            this.isLoaded = true;

            this.busyAll = false;
          }
          this.universities = allUni;
          this.universities.push(
            new Object({
              id: this.notUniversity,
              text: "سایر دانشگاه‌ها",
            })
          );
        });
        this.$http
          .post(
            this.baseUrl + "/setad/admin/referees",
            {
              projectId: this.$route.params.id,
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res2) => {
            this.reviewersFields.push(
              ...res2.data.map((x) => {
                return {
                  id: x.id,
                  text: x.name,
                };
              })
            );
          });
      }
      this.$http
        .post(
          this.baseUrl + "/setad/options/accelerators",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.accelerators = res.data;
          this.accelerators.forEach((x) => {
            x.text = x.name;
          });
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
  },
  mounted() {
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
        this.isLoaded = true;
      }
    }, this.isLoadedTimeOut);
    this.showProject();
    this.onMounted();
  },

  updated() {
    // this.busyAll = false
  },
};
</script>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.select2 {
  width: 100% !important;
}

select {
  min-width: max-content;
  width: 100%;
}

.required {
  color: red;
}

.done {
  color: green;
}
.btn-dark {
  color: #fff !important;
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.btn-light {
  color: #fff !important;
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  color: #fff !important;
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  color: #fff !important;
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  color: #fff !important;
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}
</style>
<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}

.contract-section {
  .custom-control-inline {
    margin-right: 0 !important;
  }
}
#forceFinishedModal___BV_modal_header_ {
  button {
    margin: -1rem !important;
  }
}

.diabled-textarea {
  color: grey;
  border-radius: 6px;
  padding: 8px 12px;
  width: 100%;
  min-height: 45px;
  position: relative;
  padding-top: 10px;
  background-color: #e4e7ea;
}
</style>
